// All the fetches are in one file, so the whole thing can be easily mocked
// import fetch from "cross-fetch";
import _ from "underscore";
import download from "downloadjs";
import moment from "moment";
import md5 from "md5";
import { Auth, Hub } from "aws-amplify";
import { UNAUTH_EVENT } from "App.jsx";
// import xhr from "xhr";
// import { Storage } from 'aws-amplify';

import {
	addOrRemoveString,
	aggregateTimeseries,
	cloneObjectWithout,
	langCodeLookup,
	mergeEntityFilters,
	trimSeries,
} from "@exovera/helpers";

import { SEARCH_STATE_IDS } from "actions/constants/stateIds.js";

import {
	MEDIA_ROUTE,
	CURATED_ROUTE,
	GRAPH_ROUTE,
	SOCIAL_MEDIA_ROUTE,
	NARRATIVES_ROUTE,
	EXPLORER_ROUTE,
	GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
} from "constants/constants.js";

import {
	SEARCH_RECEIVE_USER_SEARCHES,
	SEARCH_PROACTIVELY_DELETE_USER_CREATED_SEARCH,
	SEARCH_CLOSE_DELETE_SEARCH_MODAL,
	SEARCH_ADD_USER_CREATED_SEARCH,
	SEARCH_SET_ACTIVE_SEARCH,
	SEARCH_UPDATE_SEARCH_INPUT,
	SEARCH_SAVE_USER_SEARCH_SUCCESS,
	SEARCH_CLOSE_CREATE_SEARCH_MODAL,
	SEARCH_SAVE_USER_SEARCH_SPINNER,
	SEARCH_SAVE_USER_SEARCH_ERROR,
	SEARCH_RECEIVE_SEARCH_LIST,
	SEARCH_FETCHING_DYNAMIC_FILTERS,
	SEARCH_RECEIVE_DYNAMIC_FILTERS,
	SEARCH_RECEIVE_DYNAMIC_FILTERS_ERROR,
	SEARCH_FETCHING_ENTITY_FILTERS,
	SEARCH_RECEIVE_ENTITY_FILTERS,
	SEARCH_RECEIVE_ENTITY_FILTERS_ERROR,
	SEARCH_RECEIVE_ENTITY_FILTERS_RETRY,
	SEARCH_FETCHING_FILTERS,
	SEARCH_RECEIVE_FILTERS,
	SEARCH_RECEIVE_FILTERS_ERROR,
	SEARCH_RECEIVE_FILTERS_RETRY,
	SEARCH_SET_ENTITY_TYPE,
	SEARCH_ZOOM_COMPLETE,
	SEARCH_SET_ACTIVE_EXPANDED_QUERY,
	SEARCH_SET_ACTIVE_EXPANDED_QUERY_LOADING,
} from "actions/constants/searchActionTypes";

import {
	ADD_MEDIA_TIMESERIES,
	ADD_TRANSLATION_TO_TRANSCRIPTS,
	CONTENT_NAVIGATION,
	ERROR_LOADING_TWEETS,
	FETCHING_DATA_EXPLORER_PDF_DATA,
	FETCHING_MEDIA_ARTICLES,
	FETCHING_POST_COMMENTS,
	FETCHING_REPORTS,
	FETCHING_TWEETS,
	FILTER_CONTENT_BY_DATE,
	NO_POST_COMMENTS,
	RECEIVE_ALT_NARRATIVES_FOR_CROSSTABS,
	RECEIVE_ARTICLES_ERROR,
	RECEIVE_ARTICLES_RETRY,
	RECEIVE_PHRASES_LEFT,
	RECEIVE_PHRASES_RIGHT,
	RECEIVE_CONTENT_ENTITIES,
	RECEIVE_CROSSTABS_MAP_STATS,
	RECEIVE_CROSSTABS_STATS,
	REQUEST_DATA_EXPLORER_ENTITIES,
	RECEIVE_DATA_EXPLORER_ENTITIES,
	RECEIVE_DATA_EXPLORER_ENTITIES_ERROR,
	RECEIVE_DATA_EXPLORER_ENTITIES_RETRY,
	RECEIVE_DATA_EXPLORER_PDF_DATA,
	RECEIVE_DATA_EXPLORER_PDF_DATA_ERROR,
	RECEIVE_DATA_EXPLORER_PDF_DATA_RETRY,
	RECEIVE_DATA_EXPLORER_SINGLE_ARTICLE,
	RECEIVE_DATA_EXPLORER_SINGLE_ARTICLE_ERROR,
	RECEIVE_MEDIA_ARTICLES,
	RECEIVE_MEDIA_ARTICLES_ERROR,
	RECEIVE_MEDIA_ARTICLES_RETRY,
	RECEIVE_MEDIA_TIMESERIES,
	RECEIVE_MEDIA_TIMESERIES_ERROR,
	RECEIVE_MEDIA_TIMESERIES_RETRY,
	RECEIVE_NARRATIVE_MODAL_BARGRAPH,
	RECEIVE_NARRATIVE_MODAL_TIMESERIES,
	RECEIVE_PHRASES,
	RECEIVE_POST_COMMENTS,
	RECEIVE_REPORTS,
	RECEIVE_VIDEO_DATA,
	RECEIVE_TOPIC_STATS,
	RECEIVE_TWEETS,
	RECEIVE_USER_SUBSCRIPTIONS,
	RECEIVE_VIDEO_ENTITIES,
	RECEIVE_VIDEO_FEED,
	RECEIVE_VIDEO_FILTERS,
	REQUEST_PHRASES,
	REQUEST_COMPARE_PHRASES_LEFT,
	REQUEST_COMPARE_PHRASES_RIGHT,
	RESET_DATA,
	SAVE_FILTER_SET_SPINNER,
	SET_PROJECT,
	SET_CURRENT_ZOOM,
	SETUP_TOPIC_STATS,
	PROCESSING_INITIAL_TRENDS_REQUEST,
	MAP_DATA_LOADING,
	RECEIVE_MAP_DATA,
	RECEIVE_MAP_DATA_ERROR,
	RECEIVE_MAP_DATA_RETRY,
	FETCHING_USER_GUIDE_DATA,
	RECEIVE_USER_GUIDE_DATA,
	RECEIVE_USER_GUIDE_DATA_ERROR,
	FETCHING_HELP_VIDEO_DATA,
	RECEIVE_HELP_VIDEO_DATA,
	RECEIVE_HELP_VIDEO_DATA_ERROR,
	FETCHING_CATALOG_DATA,
	RECEIVE_CATALOG_DATA,
	RECEIVE_CATALOG_DATA_ERROR,
	INIT_DOCUMENT_SUMMARIZATION,
	RECEIVE_DOCUMENT_SUMMARIZATION,
	RECEIVE_DOCUMENT_SUMMARIZATION_ERROR,
	MEDIA_FETCHING_SOURCE_COUNTRY_FILTERS,
	MEDIA_RECEIVE_SOURCE_COUNTRY_FILTERS,
	MEDIA_RECEIVE_SOURCE_COUNTRY_FILTERS_RETRY,
	MEDIA_RECEIVE_SOURCE_COUNTRY_FILTERS_ERROR,
	MEDIA_FETCHING_ALL_SOURCE_COUNTRY_FILTERS,
	MEDIA_RECEIVE_ALL_SOURCE_COUNTRY_FILTERS,
	MEDIA_RECEIVE_ALL_SOURCE_COUNTRY_FILTERS_RETRY,
	MEDIA_RECEIVE_ALL_SOURCE_COUNTRY_FILTERS_ERROR,
} from "actions/constants.js";

import {
	ENTITY_VIEW_FETCH_ENTITY_DATA,
	ENTITY_VIEW_RECEIVE_ENTITY_DATA,
	ENTITY_VIEW_RECEIVE_ENTITY_DATA_ERROR,
	ENTITY_VIEW_RECEIVE_ENTITY_DATA_RETRY,
	ENTITY_VIEW_FETCH_ENTITY_RELATION_DATA,
	ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA,
	ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA_ERROR,
	ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA_RETRY,
	ENTITY_VIEW_FETCH_EXPAND_GRAPH_DATA,
	ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA,
	ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_ERROR,
	ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_RETRY,
	ENTITY_VIEW_FETCH_GRAPH_DATA,
	ENTITY_VIEW_RECEIVE_GRAPH_DATA,
	ENTITY_VIEW_RECEIVE_GRAPH_DATA_ERROR,
	ENTITY_VIEW_RECEIVE_GRAPH_DATA_RETRY,
	ENTITY_VIEW_FETCH_MEDIA_MENTIONS,
	ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS,
	ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_ERROR,
	ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_RETRY,
	ENTITY_VIEW_FETCH_TIME_SERIES,
	ENTITY_VIEW_RECEIVE_TIME_SERIES,
	ENTITY_VIEW_RECEIVE_TIME_SERIES_ERROR,
	ENTITY_VIEW_RECEIVE_TIME_SERIES_RETRY,
	ENTITY_VIEW_SET_DISABLE_EXPORT_BUTTON,
} from "actions/constants/entityViewActionTypes.js";

import {
	FETCH_AGENT_SUCCESS,
	FETCH_AGENT_FAILURE,
	FETCH_AGENTS_SUCCESS,
	AGENT_FETCH_ENTITY_RELATION_DATA,
	AGENT_RECEIVE_ENTITY_RELATION_DATA,
	AGENT_RECEIVE_ENTITY_RELATION_DATA_ERROR,
	AGENT_RECEIVE_ENTITY_RELATION_DATA_RETRY,
	AGENT_FETCH_GRAPH_DATA,
	AGENT_RECEIVE_GRAPH_DATA,
	AGENT_RECEIVE_GRAPH_DATA_ERROR,
	AGENT_RECEIVE_GRAPH_DATA_RETRY,
	AGENT_FETCH_EXPAND_GRAPH_DATA,
	AGENT_RECEIVE_EXPAND_GRAPH_DATA,
	AGENT_RECEIVE_EXPAND_GRAPH_DATA_ERROR,
	AGENT_RECEIVE_EXPAND_GRAPH_DATA_RETRY,
} from "actions/agent-actions.js";

import { setActiveChatConfig } from 'actions/chatActions';

import { setProject } from "actions/login.js";

import {
	DYNAMIC_FILTER_TYPE,
	DYNAMIC_FILTER_RESULT_TYPE,
	decorateFilters,
	addConfigFilters,
	alignPerspectiveOnLocationFilters,
	formatQueryAddsForPost,
	formatQueryExcludesForPost,
	formatFiltersForPost,
	formatHierarchyFiltersForPost,
	reactivateFilters,
} from "lib/helpers/filterHelpers.js";

import {
	describeFilters,
	determineSliceInDays,
	findCommonRange,
	formatFilters,
	isThisAnEvent,
	setStartDate,
} from "lib/helpers/helpers.js";
import { adjustStartDateForAggregation } from "lib/helpers/graphHelpers.js";
import { formatNarrativeBarGraph } from "lib/helpers/crosstabsHelpers.js";
import headerTypes from "lib/table/tableHeaders.js";
import {
	buildTableHeaders,
	allQuotesSingle,
	allQuotesDouble,
	allQuotesDoubleTemporary,
} from "lib/helpers/mediaHelpers.js";
import { assignStaticColor, colors } from "lib/helpers/helpers.js";

import { receiveTrends } from "actions/trends.js";
import { requestAnalysis, receiveAnalysis } from "actions/analysis.js";
import { receiveArticles } from "actions/articles.js";
import { updateData } from "actions/data.js";
import { receiveMapData } from "actions/map.js";
import { submitSupportTicketInit, supportTicketSubmitResponse } from "actions/support.js";
import {
	submitRFISupportTicketInit,
	submitRFISupportTicketResponse,
	submitRFISupportTicketError,
} from "actions/rfi-support.js";

import {
	receiveMapDataCompare,
	receiveTimeseriesCompare,
	receiveCompareArticles,
	receiveCorrelation,
} from "actions/compare.js";

import {
	graphTransformer,
	graphExtendTransformer,
} from "layout/EntityView/transformers/graphTransformer.js";
import { ENTITY_EXPORT_TYPE_PDF, ENTITY_EXPORT_TYPE_CSV } from "layout/EntityView/constants.js";
import entityTransformer from "layout/EntityView/transformers/entityTransformer.js";
import edgeTransformer from "layout/EntityView/transformers/edgeTransformer.js";
import { DATASET_ID_ENTITIES, DATASET_ID_MEDIA, DATASET_ID_CURATED, DATASET_ID_NARRATIVES } from "layout/DataExplorer/DataExplorerConstants.js";

// import { receiveContentExport } from "actions/content.js";
// import { parseTranscript } from "lib/helpers/videoHelpers.js";

// import fakeMapData from "lib/mockData/afghanMap.js";
// import mockAPI from "lib/mockData/mockAPI.js";
// import mockCorrelation from "lib/mockData/mockCorrelation.js";
// import mockCreateResponse from "lib/mockData/mockCreateResponse.js";
// import mockSavedFilters from "lib/mockData/mockSavedFilters.js";
// import mockSavedSearches from "lib/mockData/mockSavedSearches.js";
// import mockSingleArticle from "lib/mockData/mockSingleArticle.js";
// import mockShareData from "lib/mockData/mockShareData.js";
import mockReports from "../../lib/mockData/mockReports";
// import { mockProcurement2 } from "../../lib/mockData/mockProcurement.js";
import { MAX_DYNAMIC_FILTERS } from "../../lib/helpers/filterHelpers";
// import mockTweets from "../../lib/mockData/mockTweets";
// import mockExpandedContent from "lib/mockData/mockExpandedContent.js";
// import mockCandidates from "lib/mockData/mockCandidates.js";

const SERVER_ERROR = "Bad response from server";
const FETCH_RETRY_MAX = 1;
const CONTENT_PAGE_LENGTH = 50;

const getTabIdFromStateId = (stateId) => {
	let tabId;
	switch (stateId) {
		case SEARCH_STATE_IDS.MEDIA:
			tabId = MEDIA_ROUTE;
			break;
		case SEARCH_STATE_IDS.SOCIAL_MEDIA:
			tabId = SOCIAL_MEDIA_ROUTE;
			break;
		case SEARCH_STATE_IDS.NARRATIVES:
			tabId = NARRATIVES_ROUTE;
			break;
		case SEARCH_STATE_IDS.EXPLORER:
			tabId = EXPLORER_ROUTE;
			break;
		default:
			break;
	}
	return tabId;
};

function getRandomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function dispatchTokenFailure() {
	Hub.dispatch("TokenFailureChannel", {
		event: UNAUTH_EVENT,
		data: null,
		message: "Unauthorized",
	});
}

export async function checkRefreshToken() {
	try {
		const session = await Auth.currentSession();
		let accessToken = session.getAccessToken().getJwtToken();
		let idToken = session.getIdToken().getJwtToken();
		return {accessToken, idToken};
	} catch (error) {
		dispatchTokenFailure();
		throw new Error('Token validation failed');
	}
}

export const randomUSCCKey = () => {
	const usccKeys = [
		"trumpKey",
		"taxKey",
		"dacaKey",
		"borderKey",
		"tradeKey",
		"texaspolKey",
		"hurdKey",
		"ortizKey",
		"cornynKey",
		"cruzKey",
		"betoKey",
		"abbottKey",
	];
	return usccKeys[getRandomInt(0, usccKeys.length - 1)];
};

// CognitoIdentityServiceProvider.4qn94eh0gheufak1vuqvtrhpap.Tyler.idToken
// This dispatches all the fetches needed to seed the app, with the default params
// Make sure it only gets called on load! Happens right after login
// NOTE: shareDataObject is only passed if loading as part of a share URL
export function fetchTrends(shareDataObject) {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const staging = getState().base.stagingData;
		const { topicsPie } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Store record of initial trends request having been sent
		dispatch({ type: PROCESSING_INITIAL_TRENDS_REQUEST });
		// forcibly refresh tokens
		return checkRefreshToken().then(({accessToken, idToken}) => {
			// if api.key is false, use a GET request
			if (api.key) {
				// return fetch(`${api.narratives}?staging=${staging}`, {
				return fetch(`${api.narratives}?staging=wip`, {
					method: "POST",
					mode: "cors",
					body: JSON.stringify({
						MOE: true,
						project: api.key,
						userName,
						userPool,
						user: `${userName}_${userPool}`,
						// startDate: startDate ? startDate.toString() : null,
						// endDate: endDate ? endDate.toString() : null,,
						// slice: 15,
						// narrative,
						// perspective,
						// filters: formatFiltersForPost(filtersList),
					}),
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
						// 'Access-Control-Allow-Origin': '*',
					},
				})
					.then((response) => response.json())
					.then((json) => {
						dispatch(
							receiveTrends({
								json,
								noInit: !!shareDataObject,
								sharedActiveNarrativeData: shareDataObject
									? shareDataObject.activeNarrativeData
									: false,
							})
						);
						// Narrative tab share data fetch
						if (shareDataObject) {
							const {
								activeFilters,
								activeNarrativeData,
								entityFilters,
								contentFilteredByDate,
								currentZoom,
								keywords,
								mapHighlightId,
								perspective,
								relevancyOverride,
							} = shareDataObject;
							dispatch(
								updateData({
									activeFilters,
									contentFilteredByDate,
									entityFilters,
									currentZoom,
									keywords,
									mapHighlightId,
									nar: activeNarrativeData,
									perspective,
									relevancyOverride,
									topicsPie,
								})
							);
						}
					})
					.catch((error, json) => {
						console.log(json);
						console.error(error);
					});
			} else {
				api.optionsForGET["headers"]["authorization"] = idToken;
				return fetch(
					`${api.narratives}?staging=${staging}&userName=${userName}&userPool=${userPool}`,
					api.optionsForGET
				)
					.then((response) => response.json())
					.then((json) => dispatch(receiveTrends({ json, noInit: !!shareDataObject })))
					.catch((error, json) => {
						console.log(json);
						console.error(error);
					});
			}
		});
	};
}

export function fetchAltNarrativesForCrosstabs(projectId) {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.narratives}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					MOE: true,
					project: projectId,
					userName,
					userPool,
					user: `${userName}_${userPool}`,
					// startDate: startDate ? startDate.toString() : null,
					// endDate: endDate ? endDate.toString() : null,,
					// slice: 15,
					// narrative,
					// perspective,
					// filters: formatFiltersForPost(filtersList),
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => {
					const narratives = _.find(json, (data) => {
						return data.id === "narratives";
					});
					const flatNarratives = [narratives];
					_.each(narratives.children, (nar) => {
						flatNarratives.push(nar);
						_.each(nar.children, (childNar) => {
							flatNarratives.push(childNar);
						});
					});
					dispatch({
						type: RECEIVE_ALT_NARRATIVES_FOR_CROSSTABS,
						flatNarratives,
					});
				})
				.catch((error, json) => {
					console.log(json);
					console.error(error);
				});
		});
	};
}

// ------------ Curated Tab -------------
// This dispatches the fetch for the content - returns all content
// Make sure it only gets called on load! Happens right after login
export const fetchContent = () => {
	return (dispatch, getState) => {
		dispatch({ type: "requestContent" });
		const { api, userData, userName, authToken } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { dateStart, dateEnd } = getState().contentTab;
		const { useInternalTranslation } = getState().projectConfig;
		const { selectedGoogleTranslateLang } = getState().expandedContent;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.content}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					// ai: aiOnly, // No AI for content tab
					contentTab: true,
					endDate: dateEnd ? dateEnd.toString() : null,
					filters: [],
					perspective: "Source",
					project: api.key,
					showDuplicates: true,
					slice: 15,
					startDate: dateStart ? dateStart.toString() : null,
					translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
					translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => dispatch({ type: "contentIsHere", articles: json }))
				.catch((error, json) => {
					console.log("fetchContent error", json);
					console.error("fetchContent error", error);
				});
		});
	};
};

export const fetchContentFilters = (params) => {
	const { aiOverride } = params;

	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const { aiOnly } = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.contentFilters}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					// TODO: UNMOCK this
					// project: 'e785c152058a28fac18d3f3e1a7088dc', // mock filters - GEC
					project: api.key,
					// ai: typeof aiOverride !== "undefined" ? aiOverride : aiOnly, // currently no AI for content tab
					contentTab: true,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => dispatch({ type: "contentFiltersAreHere", filters: json }))
				.catch((error, json) => {
					console.log("fetchContentFilters error", json);
					console.error("fetchContentFilters error", error);
				});
		});
	};
};

export const fetchContentEntities = (params) => {
	// const { aiOverride } = params;
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const { analystSystem } = getState().projectConfig;
		// const { aiOnly } = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.contentEntities}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					// TODO: UNMOCK this
					// project: 'e785c152058a28fac18d3f3e1a7088dc', // mock filters - GEC
					project: api.key,
					// ai: typeof aiOverride !== "undefined" ? aiOverride : aiOnly, // currently no AI for content tab
					contentTab: true,
					user: `${userName}_${userPool}`,

					analystSystem,
					// endDate: fullEndDate,
					// event: isThisAnEvent({ id: narrativeId, events: getState().events.eventTypes }),
					filters: [], // filters: formatFiltersForPost(filtersList),
					// parent: narrative.parent,
					perspective: "Source",
					// narrative: narrativeId,
					// relevancy,
					slice: 15,
					// startDate,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => dispatch({ type: RECEIVE_CONTENT_ENTITIES, entities: json }))
				.catch((error, json) => {
					console.log("fetchContentEntities error", json);
					console.error("fetchContentEntities error", error);
				});
		});
	};
};

export const fetchContentArticles = (params) => {
	const { filters, dateStart, dateEnd, aiOverride, keywords, share, shareSingleArticleId } = params;
	const formattedFilters = formatFiltersForPost(filters);

	return (dispatch, getState) => {
		dispatch({ type: "requestContent" });
		dispatch({ type: "setContentTabDates", dateStart, dateEnd });
		const { api, userData, userName, authToken } = getState().login;
		// const { aiOnly } = getState().commonUI;
		const { useInternalTranslation } = getState().projectConfig;
		const { selectedGoogleTranslateLang } = getState().expandedContent;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// forcibly refresh tokens
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.content}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					// ai: typeof aiOverride !== "undefined" ? aiOverride : aiOnly, // No AI for content tab
					contentTab: true,
					endDate: dateEnd ? dateEnd.toString() : null,
					filters:
						keywords && keywords.length > 0 ? [...formattedFilters, { keywords }] : formattedFilters,
					perspective: "Source",
					// UNMOCK this
					project: api.key,
					// project: "e785c152058a28fac18d3f3e1a7088dc", // GEC
					slice: 15,
					showDuplicates: true,
					startDate: dateStart ? dateStart.toString() : null,
					translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
					translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({ type: "contentIsHere", articles: json, filters, share, shareSingleArticleId })
				)
				.catch((error, json) => {
					console.log("fetchContent error", json);
					console.error("fetchContent error", error);
				});
		});
	};
};

// ----------- Video Tab ----------
export const fetchVideoFilters = () => {
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.videoFilters}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					// project: 'e785c152058a28fac18d3f3e1a7088dc', // mock filters - GEC
					project: api.key,
					videoTab: true,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({ type: RECEIVE_VIDEO_FILTERS, filtersUI: formatFilters(json[0].children) })
				)
				.catch((error, json) => {
					console.error("RECEIVE_VIDEO_FILTERS error", error);
				});
		});
	};
};

export const fetchVideoFeed = (params) => {
	const { endDate, startDate, fetchKey, filtersList, keywords } = params;

	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const { useInternalTranslation } = getState().projectConfig;
		const { selectedGoogleTranslateLang } = getState().expandedContent;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const filtersForAPI = formatFiltersForPost(filtersList);
		const filterWithKeywords = keywords && keywords.length > 0 
			? [...filtersForAPI, { keywords }] 
			: filtersForAPI;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.articles}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					// ai: false,
					// asc: false,
					// analystSystem: false,
					// desc: true,
					endDate: endDate || Number(moment().add(7, "days").format("x")),
					filters: filterWithKeywords,
					// narratives,
					// perspective: "Source",
					// project: 'e785c152058a28fac18d3f3e1a7088dc', // mock filters - GEC
					project: api.key,
					// showDuplicates: false,
					// sort: "postDate",
					// relevancy: 0.65,
					// slice: 15,
					startDate: startDate || Number(moment().subtract(7, "days").format("x")),
					translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
					translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
					user: `${userName}_${userPool}`,
					videoTab: true,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => dispatch({ type: RECEIVE_VIDEO_FEED, videoFeed: json, fetchKey }))
				.catch((error, json) => {
					console.error("RECEIVE_VIDEO_FEED error", error);
				});
		});
	};
};

export const fetchVideoEntities = (params) => {
	const { endDate, startDate, fetchKey, filtersList, keywords } = params;

	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const filtersForAPI = formatFiltersForPost(filtersList);
		const filterWithKeywords = keywords && keywords.length > 0 
			? [...filtersForAPI, { keywords }] 
			: filtersForAPI;

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			const body = JSON.stringify({
				ai: false,
				analystSystem: false,
				endDate: endDate || Number(moment().add(7, "days").format("x")),
				event: false,
				filters: filterWithKeywords,
				perspective: "Source",
				project: api.key,
				max: 500,
				relevancy: 0.65,
				slice: 15,
				startDate: startDate || Number(moment().subtract(7, "days").format("x")),
				user: `${userName}_${userPool}`,
				videoTab: true,
			});

			return fetch(`${api.entities}`, {
				method: "POST",
				mode: "cors",
				body,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => {
					dispatch({
						type: RECEIVE_VIDEO_ENTITIES,
						entities: json,
						fetchKey,
					});
				})
				.catch((error, json) => {
					console.error(error, json);
				});
		});
	};
};

export const fetchVideo = (video) => {
	return (dispatch, getState) => {
		const { api, userEmail, userName, authToken } = getState().login;

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(
				`${api.singleArticle}?id=${video.id}&ai=false&index=${video.index}&email=${userEmail}&project=${api.project}`,
				{
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				}
			)
				.then((response) => response.json())
				.then((json) => {
					dispatch({
						type: RECEIVE_VIDEO_DATA,
						video: json,
					});
					// FLAG_ATTEMPTING_TO_TRANSLATE_MISSING_TRANSCRIPTS
					const hasTranscript = json.transcriptJson && json.transcriptJson.transcriptHtml;
					const noTranslation = !json.translationJson || !json.translationJson.segments;
					if (hasTranscript && noTranslation) {
						dispatch(translateTranscript({ data: json }));
						// const callsRequired = Math.ceil(json.transcriptJson.segments.length / 50);
						// _.times(callsRequired, (index) => {
						// 	setTimeout(() => {
						// 		dispatch(translateTranscript({ data: json, index, callsRequired }));
						// 	}, 50);
						// });
					}
				})
				.catch((error) => {
					console.error("Error in fetchVideo fetch", error);
				});
		});
	};
};

// export const fetchTopicStats = (parameters) => {
// 	const {
// 		currentFilters,
// 		endDate,
// 		dataType,
// 		fetchKey,
// 		filtersList,
// 		narrative,
// 		perspective,
// 		relevancy,
// 		startDate,
// 	} = parameters;
// 	return (dispatch, getState) => {
// 		const staging = getState().base.stagingData;
// 		const { api, userData, userName, authToken } = getState().login;
// 		const { aiOnly, aiSupport } = getState().commonUI;
// 		const { percentageTypes, analystSystem } = getState().projectConfig;
// 		const userPool = userData && userData.pool && userData.pool.userPoolId;
// 		const chartType = dataType ? dataType.id : "articleCount";

// 		const topicStatsConfig = [
// 			{
// 				id: "chinaAggregated",
// 				name: "China",
// 				// value: 812949,
// 				// beginDate: 1597881600000,
// 				// endDate: 1599696000000,
// 				children: [
// 					{
// 						id: "chinaTopic",
// 						name: "Anti CCP",
// 						// value: 500000,
// 						anti: true,
// 					},
// 					{
// 						id: "pchinaTopica",
// 						name: "Pro CCP",
// 						// value: 312949,
// 					},
// 				],
// 			},
// 			{
// 				id: "usAggregated",
// 				name: "US",
// 				// value: 143932,
// 				// beginDate: 1597881600000,
// 				// endDate: 1599696000000,
// 				left: true,
// 				children: [
// 					{
// 						id: "nusTopica",
// 						name: "Anti US",
// 						// value: 100000,
// 						anti: true,
// 					},
// 					{
// 						id: "usTopic",
// 						name: "Pro US",
// 						// value: 43932,
// 					},
// 				],
// 			},
// 		];
// 		const allChildren = [...topicStatsConfig[0].children, ...topicStatsConfig[1].children]; // assumes just 2 topics

// 		if (topicStatsConfig && allChildren) {
// 			dispatch({ type: SETUP_TOPIC_STATS, topicStatsConfig, expectedNarratives: allChildren.length });

// 			_.each(allChildren, (child) => {
// 				const params = JSON.stringify({
// 					aggregate: 7,
// 					ai: aiOnly,
// 					analystSystem,
// 					// FLAG_DISABLED_GRAPH_DATA_TYPE_SELECTOR_IN_REACTION
// 					chartType: perspective !== "Audience" ? chartType : "articleCount",
// 					endDate: endDate ? endDate.toString() : null,
// 					event: false,
// 					narrative: child.id,
// 					parent: child.parent,
// 					perspective,
// 					project: api.key,
// 					filters: formatFiltersForPost(alignPerspectiveOnLocationFilters(filtersList, perspective)),
// 					startDate: startDate ? startDate.toString() : null,
// 					relevancy,
// 					user: `${userName}_${userPool}`,
// 				});

// 				return fetch(`${api.timeseries}?staging=${staging}`, {
// 					method: "POST",
// 					mode: "cors",
// 					body: params,
// 					headers: {
// 						"Content-Type": "application/json",
// 					},
// 				})
// 					.then((response) => response.json())
// 					.then((json) =>
// 						dispatch({
// 							type: RECEIVE_TOPIC_STATS,
// 							timeseries: json,
// 							narrative: child,
// 						})
// 					)
// 					.catch((error) => {
// 						console.error(error);
// 					});
// 			})
// 		}

// 	};
// }

export function fetchStats() {
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			if (api.stats) {
				return fetch(`${api.stats}?staging=${staging}`, {
					method: "POST",
					mode: "cors",
					body: JSON.stringify({
						project: api.key,
						ai: aiOnly,
						user: `${userName}_${userPool}`,
					}),
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				})
					.then((response) => response.json())
					.then((json) => dispatch({ type: "receiveStats", data: json }))
					.catch((error, json) => {
						console.log("fetchStats error", json);
						console.error("fetchStats error", error);
					});
			} else {
				console.warn("Stats endpoint not defined");
			}
		});
	};
}

// ----------- Filters ----------
// Get the current user's list of filter
export function fetchSavedFilters() {
	return (dispatch, getState) => {
		const { api, currentProject, userData, userName } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			const userId = `${userName}_${userPool}`;
			return fetch(`${api.saveFilters}/${userId}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					dispatch({
						type: "receiveSavedFilters",
						savedFilters: json && json.payload,
						currentProject,
					});
				})
				.catch((error, json) => {
					console.log("receiveSavedFilters error", json);
					console.error("receiveSavedFilters error", error);
				});
		});
	};
}

export function saveFilterSet(params) {
	const { perspective } = params;
	return (dispatch, getState) => {
		dispatch({
			type: SAVE_FILTER_SET_SPINNER,
			payload: {
				saveFilterSpinner: true,
				saveFilterError: false,
			},
		});
		const { api, currentProject, userData, userName } = getState().login;
		const {
			entityFiltersListedInModal,
			filtersListedInModal,
			saveFilterModalData,
			saveFilterEditMode,
			saveFilterModalName,
		} = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const userId = `${userName}_${userPool}`;
		const filter = {
			userId,
			filterSetId: saveFilterModalData.filterSetId, // Used for DELETE. Ignored when saving
			project: currentProject,
			name: saveFilterModalName,
			perspective,
			filters: filtersListedInModal,
			entityFilters: perspective === "Source" ? entityFiltersListedInModal : [], // just in case
			// used to match against active filters.
			filterString: describeFilters({
				filtersList: mergeEntityFilters({
					activeFilters: _.reject(filtersListedInModal, (filt) => {
						return filt.parent === "keywords";
					}), // Keywords are in here
					entityFilters: entityFiltersListedInModal,
					perspective,
					keywords: _.filter(filtersListedInModal, (filt) => {
						return filt.parent === "keywords";
					}),
				}),
			}),
		};

		// If we're updating the filter, delete the old one then we'll make a new one (dynamoDB UpdateItem is not cooperating)
		if (saveFilterEditMode) {
			dispatch(deleteSavedFilter({ filter }));
		}

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(api.saveFilters, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify(filter),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => {
					filter.filterSetId = json ? json.id : "failedId";
					dispatch({ type: "saveFilterSetSuccess", response: json, filter });
					setTimeout(() => {
						dispatch({ type: "closeSaveFilterModal" });
					}, 1000);
				})
				.catch((error) => {
					dispatch({ type: "saveFilterSetError" });
					console.error("saveFilterSet error", error);
				});
		});
	};
}

export function deleteSavedFilter(params) {
	const { filter } = params;
	return (dispatch, getState) => {
		dispatch({ type: "closeDeleteFilterModal" });
		dispatch({ type: "proactivelyRemoveFilterSet", filter });
		const { api, userData, userName } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const userId = `${userName}_${userPool}`;

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(api.saveFilters, {
				method: "DELETE",
				mode: "cors",
				body: JSON.stringify({
					userId,
					filterSetId: filter.filterSetId,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) => {
					// dispatch({ type: "deleteFilterSetSuccess" }); // No need, nothing needs to happen
				})
				.catch((error) => {
					dispatch({ type: "deleteFilterSetError", filter });
					console.error("deleteFilterSetError error", error);
				});
		});
	};
}

// ----------- Graph Tab ----------
export function fetchTimeseriesList(params) {
	// aiOverride only appears when calling a saved view
	// facet and option only appear when updating a facet
	const { aiOverride, facet, option } = params;
	return (dispatch, getState) => {
		const { api, userData, userName, authToken } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { graphTabActiveFacets, graphTabFacets } = getState().projectConfig;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		let activeFacets = false;
		let facetString = "";
		// replicate facetSelect reducer (so there's not a timing issue)
		if (graphTabFacets) {
			activeFacets = JSON.parse(JSON.stringify(graphTabActiveFacets));
			if (facet && option) {
				activeFacets[facet.id] = option;
			}
			_.each(activeFacets, (activeFacet, facetId) => {
				facetString = `${facetString}&${facetId}=${activeFacet.id}`;
			});
		}

		if (api.listTimeseries && userPool) {
			// Get / Refresh tokens		
			return checkRefreshToken().then(({accessToken, idToken}) => {
				return fetch(
					`${api.listTimeseries}?staging=${staging}&ai=${typeof aiOverride !== "undefined" ? aiOverride : aiOnly}${facetString}`,
					{
						method: "GET",
						mode: "cors",
						headers: {
							"Content-Type": "application/json",
							Authorization: idToken,
						},
					}
				)
					.then((response) => response.json())
					.then((json) => {
						dispatch({ type: "receiveTimeseriesList", availableLines: json });
					})
					.catch((error, json) => {
						console.log("fetchTimeseriesList error", json);
						console.error(">>>>>>> fetchTimeseriesList error", error);
					});
			});
		} else {
			if (!api.listTimeseries) {
				console.warn("listTimeseries endpoint not defined");
			}
			if (!userPool) {
				console.warn("User ID not defined");
			}
		}
	};
}

export const saveThisSearch = (dateOption) => {
	return (dispatch, getState) => {
		const { lines, saveTitleInputValue } = getState().graphTab;
		const { api, userData } = getState().login;
		const { aiOnly } = getState().commonUI;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const params = {
			project: api.key,
			userPool,
			userName: userData.username,
			search: lines,
			id: md5(saveTitleInputValue + userData.username),
			name: saveTitleInputValue,
			dateOption,
			ai: aiOnly,
		};

		dispatch({ type: "saveThisSearchConfirmation", response: "something from the API", params });
		setTimeout(() => {
			dispatch({ type: "clearSavedSearchAnimation" });
		}, 1000);
	};
};

export function fetchGraphTabFilters(params) {
	const { filterType } = params;
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		if (api.getFilters) {
			// Get / Refresh tokens		
			return checkRefreshToken().then(({accessToken, idToken}) => {
				return fetch(
					`${api.getFilters}?type=${filterType}&staging=${staging}&userName=${userName}&userPool=${userPool}&ai=${aiOnly}`,
					{
						method: "GET",
						mode: "cors",
						headers: {
							"Content-Type": "application/json",
							Authorizaton: idToken,
							// 'Access-Control-Allow-Origin': '*',
						},
					}
				)
					.then((response) => response.json())
					.then((json) =>
						dispatch({ type: "receiveGraphTabFilters", filters: json.filters, filterType: json.type })
					)
					.catch((error, json) => {
						console.log("fetchGraphTabFilters error", json);
						console.error("fetchGraphTabFilters error", error);
					});
			});
		} else {
			console.warn("getFilters endpoint not defined");
		}
	};
}

// Gets filter types by not passing a type
export function fetchGraphTabFilterOptions(params) {
	const { aiOverride } = params;
	return (dispatch, getState) => {
		const { api } = getState().login;
		const { aiOnly } = getState().commonUI;
		const staging = getState().base.stagingData;
		if (api.getFilters) {
			// Get / Refresh tokens		
			return checkRefreshToken().then(({accessToken, idToken}) => {
				return fetch(
					`${api.getFilters}?staging=${staging}&ai=${typeof aiOverride !== "undefined" ? aiOverride : aiOnly}`,
					{
						method: "GET",
						mode: "cors",
						headers: {
							"Content-Type": "application/json",
							Authorization: idToken,
							// 'Access-Control-Allow-Origin': '*',
						},
					}
				)
					.then((response) => response.json())
					.then((json) => {
						dispatch({ type: "receiveGraphTabFilterOptions", filters: json });
						dispatch(fetchTopicsList({ type: json && json.length > 0 ? json[0].name : "" }));
					})
					.catch((error, json) => {
						console.log("fetchGraphTabFilterOptions error", json);
						console.error("fetchGraphTabFilterOptions error", error);
					});
				});
		} else {
			console.warn("getFilters endpoint not defined");
		}
	};
}

export function fetchTopicsList(params) {
	const { type } = params;
	return (dispatch, getState) => {
		const { api } = getState().login;
		const { aiOnly } = getState().commonUI;
		// const staging = getState().base.stagingData;
		if (api.getTopics) {
			// Get / Refresh tokens		
			return checkRefreshToken().then(({accessToken, idToken}) => {
				return fetch(`${api.getTopics}?type=${type}&ai=${aiOnly}`, {
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
						// 'Access-Control-Allow-Origin': '*',
					},
				})
					.then((response) => response.json())
					.then((json) =>
						dispatch({
							type: "receiveGraphTabTopics",
							topics: json && json.topics && json.topics.children ? json.topics.children : [],
						})
					)
					.catch((error, json) => {
						console.log("fetchTopicsList error", json);
						console.error("fetchTopicsList error", error);
					});
			});
		} else {
			console.warn("getTopics endpoint not defined");
		}
	};
}

export const createNewTimeseries = () => {
	return (dispatch, getState) => {
		// TODO: get active filters
		const {
			availableFilters,
			createTitleKeywordValue,
			createTitleInputValue,
			createTitleUnique,
			currentFilterType,
			selectedFilters,
			selectedTimeSeries,
		} = getState().graphTab;
		const { percentageTypes } = getState().projectConfig;

		if (
			!createTitleUnique ||
			!createTitleInputValue ||
			(selectedTimeSeries <= 0 && !createTitleKeywordValue) ||
			(selectedTimeSeries.length <= 1 && selectedFilters.length <= 0 && !createTitleKeywordValue)
		) {
			dispatch({
				type: "showCreateCustomTimeseriesError",
				duplicateTitle: !createTitleUnique,
				missingTitle: !createTitleInputValue,
			});
		} else {
			dispatch({ type: "hideCreateCustomTimeseriesError" });
			const currentFilter = _.find(availableFilters, (filter) => {
				return filter.id === currentFilterType;
			});
			// API_STUB: get this working
			const { api, userData, userName } = getState().login;
			const { aiOnly } = getState().commonUI;
			const userPool = userData && userData.pool && userData.pool.userPoolId;
			// const staging = getState().base.stagingData;
			if (api.createTimeseries) {
				dispatch({ type: "requestCreateNewTimeseries" });
				// Get / Refresh tokens		
				return checkRefreshToken().then(({accessToken, idToken}) => {
					return fetch(api.createTimeseries, {
						method: "POST",
						mode: "cors",
						body: JSON.stringify({
							project: api.key,
							index: currentFilter && currentFilter.index,
							type: currentFilterType,
							name: createTitleInputValue,
							filters: formatFiltersForPost(selectedFilters),
							topics: _.pluck(selectedTimeSeries, "id"),
							keywords: createTitleKeywordValue,
							ai: aiOnly,
							user: `${userName}_${userPool}`,
						}),
						headers: {
							"Content-Type": "application/json",
							Authorization: idToken,
							// 'Access-Control-Allow-Origin': '*',
						},
					})
						.then((response) => response.json())
						.then((json) => {
							dispatch({ type: "receiveCreateNewTimeseries", data: json, percentageTypes });
							// Turn the spinner off after the animation finishes (can't leave it on, it will kill the battery)
							setTimeout(() => {
								dispatch({ type: "disableRequestingTimeSeriesSpinner" });
							}, 1000);
							// API_STUB: write a new version of fetchTimeseriesList that checks for the new TS's id in the response
							//	& refetches after a delay if it's not available
							setTimeout(() => {
								dispatch(fetchTimeseriesList({}));
							}, 2000);
						})
						.catch((error, json) => {
							console.log("createNewTimeseries error", json);
							console.error("createNewTimeseries error", error);
						});
				});
			} else {
				console.warn("createTimeseries endpoint not defined");
			}
		}
	};
};

// API_STUB: Check all this - especially body.delete
export function deleteTimeseries(line) {
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		if (api.deleteTimeseries) {
			// Get / Refresh tokens		
			return checkRefreshToken().then(({accessToken, idToken}) => {
				return fetch(`${api.deleteTimeseries}?staging=${staging}`, {
					method: "POST",
					mode: "cors",
					body: JSON.stringify({
						project: api.key,
						delete: line,
						user: `${userName}_${userPool}`,
					}),
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
						// 'Access-Control-Allow-Origin': '*',
					},
				})
					.then((response) => response.json())
					.then((json) => dispatch({ type: "deleteTimeseriesSuccess", response: json, line }))
					.catch((error, json) => {
						dispatch({ type: "deleteTimeseriesError", error, json, line });
						console.log("deleteTimeseries error", json);
						console.error("deleteTimeseries error", error);
					});
			});
		} else {
			console.warn("deleteTimeseries endpoint not defined");
		}
	};
}

// API_STUB: test all this
export function deleteSavedSearch(search) {
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const staging = getState().base.stagingData;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		if (api.deleteSavedSearch) {
			// Get / Refresh tokens		
			return checkRefreshToken().then(({accessToken, idToken}) => {
				return fetch(`${api.deleteSavedSearch}?staging=${staging}`, {
					method: "POST",
					mode: "cors",
					body: JSON.stringify({
						project: api.key,
						delete: search,
						user: `${userName}_${userPool}`,
					}),
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
						// 'Access-Control-Allow-Origin': '*',
					},
				})
					.then((response) => response.json())
					.then((json) => dispatch({ type: "deleteSavedSearchSuccess", response: json, search }))
					.catch((error, json) => {
						dispatch({ type: "deleteSavedSearchError", error, json, search });
						console.log("deleteSavedSearch error", json);
						console.error("deleteSavedSearch error", error);
					});
			});
		} else {
			console.warn("deleteSavedSearch endpoint not defined");
		}
	};
}

export function fetchAnalysis(baseTrendMeta) {
	return (dispatch, getState) => {
		dispatch(requestAnalysis());
		const { api } = getState().login;
		const { aiOnly } = getState().commonUI;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			api.optionsForGET["headers"]["authorization"] = idToken;
			// Getting full analysis. Pass 'narrative_id' to just get specific analysis (doesn't work right now)
			return fetch(`${api.analysis}?ai=${aiOnly}`, api.optionsForGET)
				.then((response) => response.json())
				.then((json) => dispatch(receiveAnalysis(json, baseTrendMeta)))
				.catch((error) => {
					console.error(error);
				});
		});
	};
}

// ------------ Narratives Tab -------------

// Narratives - Articles
let articlesAbortController;
const abortArticlesFetch = () => {
	if (articlesAbortController) {
		articlesAbortController.abort();
	}
};

function doFetchArticles(parameters) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		adjustForAggregation = false,
		dispatch,
		getState,
		sortAscending,
		analystSystem,
		perspective,
		currentFilters,
		endDate,
		eventType,
		fetchKey,
		filters,
		narrative,
		query,
		relevancy,
		showDuplicates,
		sortBy,
		startDate,
		pageLength,
		offset,
	} = parameters;

	const staging = getState().base.stagingData;
	const { api, userData, userName } = getState().login;
	const { aiOnly } = getState().commonUI;
	const { projectSpecificTagFormat, useInternalTranslation } = getState().projectConfig;
	const { aggregationLevel, articlesFetchingRetryCount } = getState().base;
	const { selectedGoogleTranslateLang } = getState().expandedContent;

	const narrativeId = narrative && narrative.id !== "narratives" ? narrative.id : null;
	const userPool = userData && userData.pool && userData.pool.userPoolId;
	const backupShowDuplicates = getState().base.showDuplicates;

	const formattedFilters = formatHierarchyFiltersForPost(filters);
	const queryAdd = formatQueryAddsForPost(currentFilters);
	const queryExclude = formatQueryExcludesForPost(currentFilters);

	// Get / Refresh tokens		
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const {articlesFetching } = getState().base;
		if (articlesFetching) {
			abortArticlesFetch();
		}
		articlesAbortController = new AbortController();
		return fetch(`${api.articles}?staging=${staging}`, {
			method: "POST",
			signal: articlesAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				ai: aiOnly,
				asc: sortAscending,
				analystSystem,
				desc: !sortAscending,
				endDate: endDate || Date.now(),
				event: eventType,
				filters: formattedFilters,
				narrative: narrativeId,
				parent: narrativeId ? narrative.parent : null,
				perspective,
				project: api.key,
				query,
				queryAdd,
				queryExclude,
				queryExpand: activeSearchTranslationEnabled,
				queryExpandLang: activeSearchTranslationLanguages,
				showDuplicates: typeof showDuplicates === "undefined" ? backupShowDuplicates : showDuplicates,
				slice: 15,
				sort: sortBy ? [sortBy] : [],
				relevancy,
				startDate: adjustForAggregation
					? adjustStartDateForAggregation({ startDate, aggregationLevel }).toString()
					: startDate,
				translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
				translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
				user: `${userName}_${userPool}`,
				pageLength,
				offset,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				return dispatch(
					receiveArticles({
						articles: json,
						narrative,
						perspective,
						filtersList: currentFilters,
						currentFilters,
						projectSpecificTagFormat,
						fetchKey,
					})
				);
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (articlesFetchingRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: RECEIVE_ARTICLES_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${articlesFetchingRetryCount + 1}...`);
					dispatch({ type: RECEIVE_ARTICLES_RETRY });
					doFetchArticles(parameters);
				}
			});
	});
}

export function fetchArticlesInit(params) {
	const { startDate, endDate, relevancy } = params;
	return (dispatch, getState) => {
		const {
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			perspective,
			showDuplicates,
			pageLength,
			offset,
		} = getState().base;
		const { filters } = getState().search[SEARCH_STATE_IDS.NARRATIVES];

		dispatch({ type: "requestArticles" });
		const { analystSystem, projectMapConfig } = getState().projectConfig;
		const configStateFilter =
			projectMapConfig && projectMapConfig.narratives && projectMapConfig.narratives.state;
		const allFilters = configStateFilter ? addConfigFilters([], configStateFilter, filters) : [];
		const currentFilters = configStateFilter ? reactivateFilters(filters, filtersList) : filters;

		// Set the sort variables by perspective
		const contentHeaderSortAscending =
			perspective === "Source"
				? contentHeaderSortAscendingSource
				: contentHeaderSortAscendingAudience;

		return doFetchArticles({
			dispatch,
			getState,
			sortAscending: contentHeaderSortAscending,
			analystSystem,
			perspective: "Source",
			currentFilters: currentFilters,
			endDate,
			filters: allFilters || [],
			relevancy,
			showDuplicates,
			startDate,
			pageLength: pageLength || CONTENT_PAGE_LENGTH,
			offset: offset || 0,
		});
	};
}

export function fetchArticles(parameters) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		ascending,
		currentFilters,
		endDate,
		fetchKey,
		filters,
		narrative,
		perspective,
		query,
		relevancy,
		showDuplicates,
		sortBy,
		startDate,
		pageLength,
		offset,
	} = parameters;
	// perspective: string. must be 'Audience' or 'Source'

	return (dispatch, getState) => {
		const narrativeId = narrative.id !== "narratives" ? narrative.id : null;
		const { analystSystem } = getState().projectConfig;

		dispatch({ type: "requestArticles", narrativeId });

		return doFetchArticles({
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			dispatch,
			getState,
			sortAscending: ascending,
			analystSystem,
			perspective,
			currentFilters,
			endDate,
			eventType: isThisAnEvent({ id: narrativeId, events: getState().events.eventTypes }),
			fetchKey,
			filters,
			narrative,
			query,
			relevancy,
			showDuplicates,
			sortBy,
			startDate,
			pageLength,
			offset,
		});
	};
}

// Narratives - Individual article
export function fetchArticleData(params) {
	// log(['fetch.js 1381 - fetchArticleData', params]);
	return (dispatch, getState) => {
		const { fdate, id, index, nav, language, shares, source, title } = params;
		const { aiOnly, distractionFreeDeveloperMode } = getState().commonUI;
		const { analystSystem, expandedContentShowTweets, fakeSingleArticle } = getState().projectConfig;
		const { api, userEmail } = getState().login;
		const { activeSearchObj } = getState().search[SEARCH_STATE_IDS.NARRATIVES];

		const queryString = (activeSearchObj ? activeSearchObj.query : "");
		const isGECAnalyst = analystSystem && api.project === "gec";

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(
				`${api.singleArticle}?id=${
					fakeSingleArticle ? 14761 : id
				}&ai=${!!aiOnly}&index=${index}&language=${language}&navigation=${nav}&shares=${shares}&email=${userEmail}&query=${queryString}&projectGecAnalyst=${isGECAnalyst}&project=${api.project}`,
				{
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				}
			)
				.then((response) => response.json())
				.then((json) => {
					dispatch({
						type: "receiveArticleData",
						data: json,
						narratives: getState().base.flatNarratives,
						id,
						index,
						distractionFreeDeveloperMode,
					});
					const weShouldLoadTweets = expandedContentShowTweets && json.external_url;

					if (weShouldLoadTweets) {
						dispatch(
							resolveRedirectedURL({
								url: json.external_url,
								exoid: json.exoveraId,
								source: source || json.source,
								fdate,
								title,
							})
						);
					}
				})
				.catch((error) => {
					console.error(error);
				});
		});
	};
}

export function fetchUnsafe(article) {
	return (dispatch, getState) => {
		const { aiOnly } = getState().commonUI;
		const { api, userEmail } = getState().login;
		
		if (article["__typename"] === "TelegramPost") {
			return dispatch({
				type: "receiveUnsafeArticle",
				data: article,
			});
		}

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(
				`${api.singleArticle}?id=${article.id}&ai=${aiOnly}&getDoc=unsafe&email=${userEmail}&project=${api.project}`,
				{
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				}
			)
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: "receiveUnsafeArticle",
						data: json,
					})
				)
				.catch((error) => {
					console.error(error);
				});
		});
	};
}

export function resolveRedirectedURL(params) {
	const { url, exoid, fdate, source, title } = params;

	const thresholdMoment = moment().subtract(3, "days");
	const articleMoment = moment(fdate * 1000);
	const useCached = articleMoment.isBefore(thresholdMoment);

	return (dispatch, getState) => {
		const { api } = getState().login;

		dispatch({ type: FETCHING_TWEETS });
		if (source) {
			dispatch({ type: FETCHING_POST_COMMENTS });
		}

		return fetch(api.resolveRedirect, {
			method: "POST",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ url, exoid }),
		})
			.then((response) => response.json())
			.then((json) => {
				if (_.isObject(json) && json.errorMessage) {
					dispatch({ type: ERROR_LOADING_TWEETS, error: json });
				} else {
					dispatch(fetchTwitterData({ url: json.url, useCached }));
				}
			})
			.catch((error) => {
				dispatch({ type: ERROR_LOADING_TWEETS, error });
			});
	};
}

export function fetchTwitterData(params) {
	const { url, useCached } = params;
	const tweetType = "popular"; // popular, mixed or recent
	const tweetLimit = 20;

	return (dispatch, getState) => {
		const { api, userName, authToken } = getState().login;
		// const idToken = localStorage.getItem(`CognitoIdentityServiceProvider.${authToken}.${userName}.idToken`);
		dispatch({ type: FETCHING_TWEETS });

		return fetch(`${api.searchTwitter}?url=${url}`, {
			// return fetch(`${api.searchTwitter}?url=${url}&type=${tweetType}&limit=${tweetLimit}&cached=${useCached ? "true" : "false"}`, {
			method: "GET",
			mode: "cors",
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: RECEIVE_TWEETS,
					tweets: json.tweets,
				});
			})
			.catch((error) => {
				dispatch({ type: ERROR_LOADING_TWEETS, error });
			});
	};
}

export function fetchArticleMapData(stateCode, articleID) {
	// stateCode === null for base map
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { analystSystem } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.map}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					// startDate: startDate ? startDate.toString() : null,
					// endDate: endDate ? endDate.toString() : null,,
					// narrative,
					// filters: [],
					analystSystem,
					articleID,
					slice: 15,
					includeCounties: !!stateCode, // back end needs a boolean, not just something truthy
					project: api.key,
					state: stateCode || null,
					perspective: "Audience",
					ai: aiOnly,
					user: `${userName}_${userPool}`,
					aggregationType: stateCode ? "county" : "state", // state/county/dma
					// NOTE: no relevancy data for this call, which I assume is correct (this feature wasn't installed when relevancy data was added)
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: "receiveArticleMapData",
						map: json,
						articleID,
						stateCode,
					})
				)
				.catch((error) => {
					console.error("fetchArticleMapData error:", error);
				});
		});
	};
}

// Narratives - Map data
let mapDataAbortController;
const abortMapDataFetch = () => {
	if (mapDataAbortController) {
		mapDataAbortController.abort();
	}
};

function doFetchMapData(params) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		currentFilters,
		dmaAggregation,
		endDate,
		filters,
		narrative,
		perspective,
		query,
		relevancy,
		startDate,
		stateCode, // for the state that you want county data for, or false.
		newMapSegmentSpan,
		notMOE,
		getState,
		onReceive,
		onError,
		onRetry,
		retryId,
		abortController,
		side,
	} = params;

	const staging = getState().base.stagingData;
	const { location } = getState().router;
	const { api, userData, userName } = getState().login;
	const { aiOnly } = getState().commonUI;
	const { analystSystem } = getState().projectConfig;
	const eventMode = location && location.pathname === "/events";
	const userPool = userData && userData.pool && userData.pool.userPoolId;
	const retryStateId = !side ? "base" : side === "Left" ? "leftCompare" : "rightCompare";
	const retryCount = getState()[retryStateId][retryId];

	const formattedFilters = formatHierarchyFiltersForPost(filters);
	const queryAdd = formatQueryAddsForPost(currentFilters);
	const queryExclude = formatQueryExcludesForPost(currentFilters);

	// Get / Refresh tokens		
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { mapDataLoading } = getState().base;
		if (mapDataLoading) {
			abortMapDataFetch();
		}
		mapDataAbortController = new AbortController();
		return fetch(`${api.map}?staging=${staging}`, {
			method: "POST",
			signal: mapDataAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				ai: aiOnly,
				analystSystem,
				endDate: endDate ? endDate.toString() : null,
				event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
				filters: formattedFilters,
				includeCounties: !!stateCode,
				narrative: notMOE ? (narrative.id === "narratives" ? "ALL" : narrative.id) : undefined,
				moe: !notMOE ? (narrative.id === "narratives" ? "ALL" : narrative.id) : undefined,
				parent: narrative.parent,
				// Force source for events
				perspective: eventMode ? "Source" : perspective,
				project: api.key,
				query,
				queryAdd,
				queryExclude,
				queryExpand: activeSearchTranslationEnabled,
				queryExpandLang: activeSearchTranslationLanguages,
				relevancy,
				slice: determineSliceInDays({ segmentSpan: newMapSegmentSpan, startDate, endDate }),
				startDate: startDate ? startDate.toString() : null,
				state: stateCode || null, // required for aggregationType county
				user: `${userName}_${userPool}`,
				aggregationType: stateCode ? (dmaAggregation ? "dma" : "county") : "state", // state/county/dma
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				onReceive(json);
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (retryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					onError(error);
				} else {
					console.warn(`${error} - Retry attempt ${retryCount + 1}...`);
					onRetry(error);
					doFetchMapData(params);
				}
			});
	});
}

export function fetchMapData(params) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		currentFilters,
		dmaAggregation,
		endDate,
		fetchKey,
		filters,
		narrative,
		perspective,
		query,
		queryAdd,
		queryExclude,
		relevancy,
		startDate,
		stateCode, // for the state that you want county data for, or false.
		currentMapSegmentSpan,
	} = params;

	return (dispatch, getState) => {
		const newMapSegmentSpan = currentMapSegmentSpan || getState().base.currentMapSegmentSpan;

		// Configure handler functions for fetch result
		const onReceive = (json) => {
			return dispatch(
				receiveMapData({
					data: json,
					narrative,
					perspective,
					filtersList: currentFilters,
					query,
					currentFilters,
					stateCode,
					fetchKey,
					currentMapSegmentSpan: newMapSegmentSpan,
				})
			);
		};
		const onError = () => {
			return dispatch({ type: RECEIVE_MAP_DATA_ERROR });
		};
		const onRetry = () => {
			dispatch({ type: RECEIVE_MAP_DATA_RETRY });
		};

		// Set map loading state to true
		dispatch({ type: MAP_DATA_LOADING });

		// Fetch the actual map data and process response
		return doFetchMapData({
			...params,
			abortController: mapDataAbortController,
			newMapSegmentSpan,
			dispatch,
			getState,
			notMOE: true,
			retryId: "mapDataRetryCount",
			onReceive,
			onError,
			onRetry,
		});
	};
}

// Narratives - Timeseries.
export function fetchTimeseries(parameters) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		currentFilters,
		endDate,
		dataType,
		fetchKey,
		filters,
		narrative,
		perspective,
		query,
		relevancy,
		startDate,
	} = parameters;

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName } = getState().login;
		const { aiOnly, aiSupport } = getState().commonUI;
		const {
			percentageTypes,
			analystSystem,
			projectMapConfig,
			topicsPie,
			topicsPieArray,
			topicStatsConfig,
		} = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const chartType = dataType ? dataType.id : "articleCount";

		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdd = formatQueryAddsForPost(currentFilters);
		const queryExclude = formatQueryExcludesForPost(currentFilters);

		const params = JSON.stringify({
			// aggregate: 7,
			ai: aiOnly,
			analystSystem,
			// FLAG_DISABLED_GRAPH_DATA_TYPE_SELECTOR_IN_REACTION
			chartType: perspective !== "Audience" ? chartType : "articleCount",
			endDate: endDate ? endDate.toString() : null,
			event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
			narrative: narrative.id,
			parent: narrative && narrative.parent,
			perspective,
			query,
			queryAdd,
			queryExclude,
			queryExpand: activeSearchTranslationEnabled,
			queryExpandLang: activeSearchTranslationLanguages,
			project: api.key,
			filters: formattedFilters,
			startDate: startDate ? startDate.toString() : null,
			relevancy,
			user: `${userName}_${userPool}`,
		});

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.timeseries}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: params,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					if (topicsPie) {
						dispatch({
							type: RECEIVE_TOPIC_STATS,
							data: JSON.parse(JSON.stringify(json)),
							narrative,
							topicsPieArray,
							topicStatsConfig,
						});
					}
					return dispatch({
						type: "receiveTimeseries",
						data: json,
						aiOnly,
						aiSupport,
						fetchKey,
						filtersList: currentFilters,
						currentFilters,
						narrative,
						percentageTypes,
						perspective,
						projectMapConfig,
						dataType,
					});
				})
				.catch((error) => {
					console.error(error);
				});
		});
	};
}

// ------------ Data Explorer Tab -------------

export function fetchDataExplorerDocument(params) {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;
		const { activeSearchObj, activeExpandedQuery } = getState().search[SEARCH_STATE_IDS.EXPLORER];
		const queryString = activeExpandedQuery || (activeSearchObj ? activeSearchObj.query : "");
		const { id, index } = params;

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(
				`${api.singleArticle}?id=${id}&index=${index}&email=${userEmail}&query=${queryString}&project=${api.project}`,
				{
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				}
			)
				.then((response) => {
					if (!response.ok) {
						throw new Error(SERVER_ERROR);
					}
					return response.json();
				})
				.then((json) => {
					// Workaround for API returning 200 OK reponses when documents
					// dont exists, really need to fix the API for this
					if (!json.id && !json?.data?.exoId && !json?.data?.originalId) {
						throw new Error(SERVER_ERROR);
					}
					dispatch({
						type: RECEIVE_DATA_EXPLORER_SINGLE_ARTICLE,
						data: json,
						id,
					});
				})
				.catch((error) => {
					dispatch({
						type: RECEIVE_DATA_EXPLORER_SINGLE_ARTICLE_ERROR,
					});
				});
		});
	};
}

// JBN document metadata
let dataExplorerPDFDataAbortController;
const abortDataExplorerPDFDataFetch = () => {
	if (dataExplorerPDFDataAbortController) {
		dataExplorerPDFDataAbortController.abort();
	}
};

function doFetchDataExplorerPDFData(params) {
	const { dispatch, getState, id, index } = params;
	const { api, userEmail } = getState().login;
	const { dataExplorerPDFModalDataRetryCount } = getState().dataExplorer;
	const { activeSearchObj, activeExpandedQuery } = getState().search[SEARCH_STATE_IDS.EXPLORER];
	const queryString = activeExpandedQuery || (activeSearchObj ? activeSearchObj.query : "");
	// Get / Refresh tokens		
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { dataExplorerPDFModalDataLoading } = getState().dataExplorer;
		if (dataExplorerPDFModalDataLoading) {
			abortDataExplorerPDFDataFetch();
		}
		dataExplorerPDFDataAbortController = new AbortController();
		return fetch(
			`${api.singleArticle}?id=${id}&index=${index}&email=${userEmail}&query=${queryString}&project=${api.project}`,
			{
				method: "GET",
				signal: dataExplorerPDFDataAbortController.signal,
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				if (!json.title && !json.originalTitle) {
					throw new Error(SERVER_ERROR);
				}
				else if (!json.title) {
					json.title = json.originalTitle;
				}
				dispatch({
					type: RECEIVE_DATA_EXPLORER_PDF_DATA,
					data: json,
					id,
				});
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (dataExplorerPDFModalDataRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: RECEIVE_DATA_EXPLORER_PDF_DATA_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${dataExplorerPDFModalDataRetryCount + 1}...`);
					dispatch({ type: RECEIVE_DATA_EXPLORER_PDF_DATA_RETRY });
					doFetchDataExplorerPDFData(params);
				}
			});
	});
}

export const fetchDataExplorerPDFData = (params) => {
	const { id, index } = params;
	return (dispatch, getState) => {
		dispatch({ type: FETCHING_DATA_EXPLORER_PDF_DATA, id, index });
		doFetchDataExplorerPDFData({ dispatch, getState, id, index });
	};
};


export function submitSupportTicket(email, subject, text, logURL) {
	return (dispatch, getState) => {
		dispatch(submitSupportTicketInit());
		const { api, currentProject } = getState().login;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			const options = {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					email,
					subject,
					text,
					logURL,
					project: `Narrative tracker: ${currentProject}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			};
			return fetch(api.support, options)
				.then((response) => response.json())
				.then((json) => dispatch(supportTicketSubmitResponse(json)))
				.catch((error, json) => {
					console.log(json);
					console.error(error);
				});
		});
	};
}

export function submitRFISupportTicket(
	email,
	datasetId,
	itemId,
	itemIndex,
	htmlHash,
	urlHash,
	rfiType,
	question,
	logURL
) {
	return (dispatch, getState) => {
		dispatch(submitRFISupportTicketInit());
		const { api, currentProject } = getState().login;
		const { pathname } = getState().router.location;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			const options = {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					email,
					subject: rfiType,
					text: question,
					logURL,
					project: `Narrative tracker: ${currentProject}`,
					context: {
						datasetId,
						itemId,
						itemIndex,
						htmlHash,
						urlHash,
						pathname,
					},
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			};
			return fetch(api.support, options)
				.then((response) => response.json())
				.then((json) => {
					dispatch(submitRFISupportTicketResponse(json));
				})
				.catch((error) => {
					console.error("API request error:", error);
					dispatch(submitRFISupportTicketError(error.message));
				});
		});
	};
}

// Fetches a single timeseries for the graph tab
export function fetchGraphTabTimeseries(parameters) {
	const { narrative, perspective, filtersList, aiOverride } = parameters;
	// aiOverride should only exist if loading a share view

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { percentageTypes } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const params = JSON.stringify({
			id: narrative.id,
			index: narrative.index,
			project: api.key,
			// interval: 7,
			filters: formatFiltersForPost(filtersList),
			ai: typeof aiOverride !== "undefined" ? aiOverride : aiOnly,
			user: `${userName}_${userPool}`,
		});
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.getTimeseries}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: params,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: "receiveGraphTabTimeseries",
						data: json,
						narrative,
						perspective,
						filtersList,
						percentageTypes,
					})
				)
				.catch((error) => {
					console.error(error);
				});
		});
	};
}

// ------------ Compare Tab/Screen -------------

let mapDataCompareLeftAbortController;
const abortMapDataCompareLeftFetch = () => {
	if (mapDataCompareLeftAbortController) {
		mapDataCompareLeftAbortController.abort();
	}
};
let mapDataCompareRightAbortController;
const abortMapDataCompareRightFetch = () => {
	if (mapDataCompareRightAbortController) {
		mapDataCompareRightAbortController.abort();
	}
};
export function fetchMapDataCompare(parameters) {
	// perspective: string. must be 'Audience' or 'Source'
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		currentFilters,
		currentMapSegmentSpan,
		dmaAggregation,
		endDate,
		fetchKey,
		filters,
		narrative,
		notMOE,
		perspective,
		query,
		relevancy,
		startDate,
		stateCode,
		side,
	} = parameters;

	return (dispatch, getState) => {
		const newMapSegmentSpan = currentMapSegmentSpan || getState().base.currentMapSegmentSpan;
		const { mapDataLoading } = side === "Left" ? getState().leftCompare : getState().rightCompare;
		const { location } = getState().router;
		const eventMode = location && location.pathname === "/events";
		const thePerspective = eventMode ? "Source" : perspective;

		let theAborter;

		// Abort any pending requests for map data
		if (side === "Left") {
			if (mapDataLoading) {
				abortMapDataCompareLeftFetch();
			}
			mapDataCompareLeftAbortController = new AbortController();
			theAborter = mapDataCompareLeftAbortController;
		} else {
			if (mapDataLoading) {
				abortMapDataCompareRightFetch();
			}
			mapDataCompareRightAbortController = new AbortController();
			theAborter = mapDataCompareRightAbortController;
		}

		// Configure handler functions for fetch result
		const onReceive = (json) => {
			return dispatch(
				receiveMapDataCompare({
					currentFilters,
					currentMapSegmentSpan: newMapSegmentSpan,
					data: json,
					fetchKey,
					filtersList: currentFilters,
					narrative,
					notMOE,
					perspective,
					side,
					stateCode,
				})
			);
		};
		const onError = () => {
			return dispatch({ type: `${RECEIVE_MAP_DATA_ERROR}_${side}` });
		};
		const onRetry = () => {
			dispatch({ type: `${RECEIVE_MAP_DATA_RETRY}_${side}` });
		};

		// Set map loading state to true
		dispatch({ type: `requestMap${side}` });

		// Fetch the actual map data and process response
		return doFetchMapData({
			...parameters,
			abortController: theAborter,
			newMapSegmentSpan,
			dispatch,
			getState,
			perspective: thePerspective,
			retryId: "mapDataRetryCount",
			notMOE,
			onReceive,
			onError,
			onRetry,
		});
	};
}

export function fetchTimeseriesCompare(parameters) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		correlationOnly,
		currentFilters,
		dataType,
		endDate,
		eventMode,
		fetchKey,
		filters,
		narrative,
		notMOE,
		parent,
		perspective,
		query,
		relevancy,
		side,
		startDate,
	} = parameters;

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { location } = getState().router;
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { analystSystem } = getState().projectConfig;

		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const chartType = dataType ? dataType.id : "articleCount";
		const eventTabMode = location && location.pathname === "/events";
		const thePerspective = eventTabMode ? "Source" : perspective;

		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdd = formatQueryAddsForPost(currentFilters);
		const queryExclude = formatQueryExcludesForPost(currentFilters);

		const body = notMOE
			? JSON.stringify({
					ai: aiOnly,
					analystSystem,
					// FLAG_DISABLED_GRAPH_DATA_TYPE_SELECTOR_IN_REACTION
					chartType: thePerspective !== "Audience" ? chartType : "articleCount",
					endDate: endDate ? endDate.toString() : null,
					event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
					filters: formattedFilters,
					narrative: narrative.id,
					parent: narrative.parent, // Force source for events
					perspective: thePerspective,
					project: api.key,
					query,
					queryAdd,
					queryExclude,
					queryExpand: activeSearchTranslationEnabled,
					queryExpandLang: activeSearchTranslationLanguages,
					relevancy,
					slice: 15,
					startDate: startDate ? startDate.toString() : null,
					user: `${userName}_${userPool}`,
				})
			: JSON.stringify({
					ai: aiOnly,
					analystSystem,
					// FLAG_DISABLED_GRAPH_DATA_TYPE_SELECTOR_IN_REACTION
					chartType: thePerspective !== "Audience" ? chartType : "articleCount",
					endDate: endDate ? endDate.toString() : null,
					event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
					filters: formattedFilters,
					moe: narrative.id,
					parent: narrative.parent,
					perspective: thePerspective,
					project: api.key,
					query,
					queryAdd,
					queryExclude,
					queryExpand: activeSearchTranslationEnabled,
					queryExpandLang: activeSearchTranslationLanguages,
					relevancy,
					startDate: startDate ? startDate.toString() : null,
					slice: 15,
					user: `${userName}_${userPool}`,
				});

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			const params = {
				method: "POST",
				mode: "cors",
				body,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			};
			return fetch(`${api.timeseries}?staging=${staging}`, params)
				.then((response) => response.json())
				.then((json) => {
					if (!correlationOnly) {
						dispatch(
							receiveTimeseriesCompare({
								data: json,
								dataType,
								narrative,
								perspective: thePerspective,
								filtersList: currentFilters,
								currentFilters,
								side,
								fetchKey,
								parent,
							})
						);
					}
				})
				.catch((error, json) => {
					console.error(error);
					console.log("fetchTimeseriesCompare error details", json);
				});
		});
	};
}

let compareArticlesAbortController = {
	Left: null,
	Right: null,
};
const abortCompareArticlesFetch = (side) => {
	if (compareArticlesAbortController[side]) {
		compareArticlesAbortController[side].abort();
	}
};

function doFetchCompareArticles(parameters) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		adjustForAggregation = false,
		dispatch,
		getState,
		ascending,
		currentFilters,
		endDate,
		fetchKey,
		filters,
		narrative,
		perspective,
		query,
		relevancy,
		showDuplicates,
		side,
		sortBy,
		startDate,
		pageLength,
		offset,
	} = parameters;

	const staging = getState().base.stagingData;
	const { location } = getState().router;
	const { analystSystem, useInternalTranslation } = getState().projectConfig;
	const { aiOnly } = getState().commonUI;
	const { api, userData, userName } = getState().login;
	const { aggregationLevel, articlesFetchingRetryCount } =
		side === "Left" ? getState().leftCompare : getState().rightCompare;
	const { selectedGoogleTranslateLang } = getState().expandedContent;

	const backupShowDuplicates = getState().base.showDuplicates;
	const eventMode = location && location.pathname === "/events";
	const thePerspective = eventMode ? "Source" : perspective;
	const userPool = userData && userData.pool && userData.pool.userPoolId;
	const formattedFilters = formatHierarchyFiltersForPost(filters);
	const queryAdd = formatQueryAddsForPost(currentFilters);
	const queryExclude = formatQueryExcludesForPost(currentFilters);

	// Get / Refresh tokens		
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { articlesFetching } = side === "Left" ? getState().leftCompare : getState().rightCompare;
		if (articlesFetching) {
			abortCompareArticlesFetch(side);
		}
		compareArticlesAbortController[side] = new AbortController();
		return fetch(`${api.articles}?staging=${staging}`, {
			method: "POST",
			signal: compareArticlesAbortController[side].signal,
			mode: "cors",
			body: JSON.stringify({
				ai: aiOnly,
				analystSystem,
				asc: ascending,
				desc: !ascending,
				endDate: endDate || Date.now(),
				event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
				filters: formattedFilters,
				narrative: narrative && narrative.id !== "narratives" ? narrative.id : null,
				perspective: thePerspective,
				project: api.key,
				parent: narrative.parent,
				query,
				queryAdd,
				queryExclude,
				queryExpand: activeSearchTranslationEnabled,
				queryExpandLang: activeSearchTranslationLanguages,
				relevancy,
				showDuplicates: typeof showDuplicates === "undefined" ? backupShowDuplicates : showDuplicates,
				slice: 15,
				sort: [sortBy],
				startDate: adjustForAggregation
					? adjustStartDateForAggregation({ startDate, aggregationLevel }).toString()
					: startDate,
				translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
				translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
				user: `${userName}_${userPool}`,
				pageLength: pageLength || CONTENT_PAGE_LENGTH,
				offset: offset || 0,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				return dispatch(
					receiveCompareArticles({
						articles: json,
						narrative,
						perspective,
						filtersList: currentFilters,
						currentFilters,
						side,
						fetchKey,
					})
				);
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (articlesFetchingRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: `${RECEIVE_ARTICLES_ERROR}_${side}` });
				} else {
					console.warn(`${error} - Retry attempt ${articlesFetchingRetryCount + 1}...`);
					dispatch({ type: `${RECEIVE_ARTICLES_RETRY}_${side}` });
					doFetchCompareArticles(parameters);
				}
			});
	});
}

export function fetchCompareArticles(parameters) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		ascending,
		currentFilters,
		endDate,
		fetchKey,
		filters,
		narrative,
		perspective,
		query,
		showDuplicates,
		relevancy,
		side,
		sortBy,
		startDate,
		pageLength,
		offset,
	} = parameters;

	if (!startDate || !endDate) {
		console.warn("Dates missing from fetchCompareArticles()", startDate, endDate);
	}
	return (dispatch, getState) => {
		const narrativeId = narrative.id !== "narratives" ? narrative.id : null;

		dispatch({ type: `requestArticles${side}`, narrativeId });

		return doFetchCompareArticles({
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			dispatch,
			getState,
			ascending,
			currentFilters,
			endDate,
			fetchKey,
			filters,
			narrative,
			perspective,
			query,
			relevancy,
			showDuplicates,
			side,
			sortBy,
			startDate,
			pageLength,
			offset,
		});
	};
}

// ------------ Media Tab -------------

// Fetch Articles (media tab)
let mediaArticlesAbortController;
const abortMediaArticlesFetch = () => {
	if (mediaArticlesAbortController) {
		mediaArticlesAbortController.abort();
	}
};

export function doFetchMediaArticles(params) {
	const {
		activeSearchTranslationEnabled,
		activeSearchTranslationLanguages,
		ascending,
		begin,
		country,
		dispatch,
		end,
		getState,
		offset,
		pageLength,
		query,
		lang,
		searchObj,
		setup,
		showTranslate,
		sortBy,
	} = params;
	const { api } = getState().login;
	const { outletFilters, aggregationLevel, articlesLoadingRetryCount, contentFilteredByDate } =
		getState().media;
	const { useInternalTranslation } = getState().projectConfig;
	const { selectedGoogleTranslateLang } = getState().expandedContent;
	const { filters, currentFiltersList, currentZoom } = getState().search[SEARCH_STATE_IDS.MEDIA];
	// const filters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
	const formattedFilters = formatHierarchyFiltersForPost(filters);
	const queryAdds = formatQueryAddsForPost(currentFiltersList);
	const queryExcludes = formatQueryExcludesForPost(currentFiltersList);
	const queryToSend = query && query.length > 0 ? query : undefined;

	// forcibly refresh tokens
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { articlesLoading } = getState().media;
		if (articlesLoading) {
			abortMediaArticlesFetch();
		}
		mediaArticlesAbortController = new AbortController();
		return fetch(`${api.getMediaContent}`, {
			method: "POST",
			signal: mediaArticlesAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				asc: ascending,
				debug: searchObj,
				desc: !ascending,
				endDate: end || null,
				index: searchObj.index,
				language: lang === "All" ? "All" : lang,
				project: api.dataKey,
				country,
				query: queryToSend,
				queryExpand: activeSearchTranslationEnabled,
				queryExpandLang: activeSearchTranslationLanguages,
				queryAdd: queryAdds,
				queryExclude: queryExcludes,
				filters: formattedFilters,
				sort: [sortBy],
				sourceState: searchObj.sourceState,
				startDate:
					begin ||
					(contentFilteredByDate
						? adjustStartDateForAggregation({ startDate: currentZoom.begin, aggregationLevel })
						: currentZoom.begin) ||
					null,
				// translate: showTranslate,
				translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
				translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
				type: searchObj.type,
				tab: "mediaTab",
				pageLength,
				offset,
				// HIDING_FOR_NOW
				// garbage: showGarbage,
				// hidden: showHidden,
				// international: showInternational,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
				// 'Access-Control-Allow-Origin': '*',
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				const resBegin = begin || json.startDate;
				const resEnd = end || json.endDate;
				dispatch({
					type: RECEIVE_MEDIA_ARTICLES,
					articles: json.articles,
					expandedQuery: json.expandedQuery,
					headers: json.headers,
					setup: !!setup,
					fetchKey: `${searchObj.id}_${searchObj.lang || "noLang"}_${searchObj.locationStr || "noLocation"}_${resBegin}to${resEnd}`,
				});
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (articlesLoadingRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: RECEIVE_MEDIA_ARTICLES_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${articlesLoadingRetryCount + 1}...`);
					dispatch({ type: RECEIVE_MEDIA_ARTICLES_RETRY });
					doFetchMediaArticles(params, lang, country, dispatch, getState);
				}
			});
		});
}

export function fetchMediaArticles(params) {
	const { searchObj, useSearchObj, pageLength, offset } = params;
	return (dispatch, getState) => {
		const { selectedLanguage, selectedCountry } = getState().media;
		const { activeSearchTranslationEnabled, activeSearchTranslationLanguages } =
			getState().search[SEARCH_STATE_IDS.MEDIA];
		const lang = useSearchObj ? searchObj.lang : selectedLanguage;
		const country = useSearchObj ? searchObj.country : selectedCountry;
		dispatch({ type: FETCHING_MEDIA_ARTICLES });
		return doFetchMediaArticles({
			...params,
			lang,
			country,
			pageLength,
			offset,
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			dispatch,
			getState,
		});
	};
}

// Fetch Single Article (media tab)
export function fetchMediaData(article) {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;
		const { activeSearchObj } = getState().search[SEARCH_STATE_IDS.MEDIA];
		const queryString = activeSearchObj ? activeSearchObj.query : "";
		const { distractionFreeDeveloperMode } = getState().commonUI;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(
				`${api.singleArticle}?id=${article.id}&index=${article.index}&search=${article.search}&email=${userEmail}&query=${queryString}&project=${api.project}`,
				{
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				}
			)
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: "receiveArticleData",
						data: json,
						narratives: getState().base.flatNarratives,
						id: article.id,
						index: article.index,
						distractionFreeDeveloperMode,
					})
				)
				.catch((error) => {
					console.error(error);
				});
		});
	};
}

// Fetch Timeseries (media tab)
let mediaTimeseriesAbortController;
const abortMediaTimeseriesFetch = () => {
	if (mediaTimeseriesAbortController) {
		mediaTimeseriesAbortController.abort();
	}
};

export function fetchMediaTimeseries(parameters) {
	const { query, id, lang, name, locationStr } = parameters.searchObj;
	return (dispatch, getState) => {
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			const { api } = getState().login;
			const {
				selectedLanguage,
				selectedCountry,
				outletFilters,
				timeseriesLoadingRetryCount,
			} = getState().media;
			const {
				activeSearchTranslationEnabled,
				activeSearchTranslationLanguages,
				timeStart,
				timeEnd,
				filters,
				currentFiltersList,
			} = getState().search[SEARCH_STATE_IDS.MEDIA];
			// const formattedFilters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
			const formattedFilters = formatHierarchyFiltersForPost(filters);
			const queryAdds = formatQueryAddsForPost(currentFiltersList);
			const queryExcludes = formatQueryExcludesForPost(currentFiltersList);
			const queryToSend = query && query.length > 0 ? query : undefined;

			const params = JSON.stringify({
				query: queryToSend,
				project: api.key,
				language: selectedLanguage,
				country: selectedCountry,
				filters: formattedFilters,
				queryAdd: queryAdds,
				queryExclude: queryExcludes,
				queryExpand: activeSearchTranslationEnabled,
				queryExpandLang: activeSearchTranslationLanguages,
				tab: "mediaTab",
				// startDate: currentZoom.begin,
				// endDate: currentZoom.end,
				startDate: timeStart,
				endDate: timeEnd,
			});

			const { lineLoading } = getState().media;
			if (lineLoading) {
				abortMediaTimeseriesFetch();
			}
			mediaTimeseriesAbortController = new AbortController();
			return fetch(`${api.getMediaTimeseries}`, {
				method: "POST",
				signal: mediaTimeseriesAbortController.signal,
				mode: "cors",
				body: params,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(SERVER_ERROR);
					}
					return response.json();
				})
				.then((json) => {
					json.id = json.id || id;
					json.name = json.name || name;

					const lines = assignStaticColor({ list: [json], colors });
					const keys = Object.keys(lines[0].timeseries);
					const rangeStart = Number(keys[0]);
					const rangeEnd = Number(keys[keys.length - 1]);
					for (let i = 0; i < lines.length; i++) {
						lines[i].weeklyTimeseries = aggregateTimeseries({
							timeseries: lines[i].timeseries,
							span: 7,
						});
						lines[i].monthlyTimeseries = aggregateTimeseries({
							timeseries: lines[i].timeseries,
							span: 30,
						});
					}
					// json.color = {
					// 	id: "Blue",
					// 	dark: "#0074E4",
					// 	darkChild: "#17588e",
					// 	light: "#0074E4",
					// 	lightChild: "#17588e",
					// 	colorblind: "colorblindDashed",
					// 	inUse: 0,
					// };
					dispatch({
						type: RECEIVE_MEDIA_TIMESERIES,
						lines,
						query,
						fetchKey: `${id}_${lang || "noLang"}_${locationStr || "noLocation"}_${rangeStart}to${rangeEnd}`,
					});

					const newZoom = {
						name: "Custom",
						value: rangeEnd - rangeStart,
						begin: rangeStart,
						end: rangeEnd,
					};
					dispatch({
						type: SEARCH_ZOOM_COMPLETE,
						stateId: SEARCH_STATE_IDS.MEDIA,
						currentZoom: newZoom,
					});
				})
				.catch((error, json) => {
					if (error.name === "AbortError") {
						// No action needed
					} else if (timeseriesLoadingRetryCount >= FETCH_RETRY_MAX) {
						console.error(error);
						dispatch({ type: RECEIVE_MEDIA_TIMESERIES_ERROR, data: json });
					} else {
						console.warn(`${error} - Retry attempt ${timeseriesLoadingRetryCount + 1}...`);
						dispatch({ type: RECEIVE_MEDIA_TIMESERIES_RETRY });
						dispatch(fetchMediaTimeseries(parameters));
					}
				});
		});
	};
}

// Fetch Timeseries to Compare (media tab)
export const fetchMediaTimeseriesToCompare = (searchObj) => {
	const { query, id, name } = searchObj;

	const stateId = SEARCH_STATE_IDS.MEDIA;

	return (dispatch, getState) => {
		const { api } = getState().login;
		const { outletFilters } = getState().media;
		const {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			currentZoom,
			filters,
			currentFiltersList,
		} = getState().search[stateId];

		// const filters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
		const formattedFilters = formatHierarchyFiltersForPost(filters);
		const queryAdds = formatQueryAddsForPost(currentFiltersList);
		const queryExcludes = formatQueryExcludesForPost(currentFiltersList);
		const queryToSend = query && query.length > 0 ? query : undefined;

		const params = JSON.stringify({
			query: queryToSend,
			project: api.key,
			filters: formattedFilters,
			queryAdd: queryAdds,
			queryExclude: queryExcludes,
			queryExpand: activeSearchTranslationEnabled,
			queryExpandLang: activeSearchTranslationLanguages,
			tab: "mediaTab",
			startDate: currentZoom.begin,
			endDate: currentZoom.end,
		});
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.getMediaTimeseries}`, {
				method: "POST",
				mode: "cors",
				body: params,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					json.id = json.id || id;
					json.name = json.name || name;
					dispatch({
						type: ADD_MEDIA_TIMESERIES,
						line: json,
						query,
					});
				})
				.catch((error) => {
					console.error(error);
				});
		});
	};
};

// ------------ Search -------------

// Fetch project searches
export function fetchSearchList(stateId) {
	return (dispatch, getState) => {
		const { api } = getState().login;
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.listMediaSearches}?key=${api.dataKey}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					const parsedSearches = json.map((x) => {
						return {
							...x,
							additionalAttributes: JSON.parse(x.additionalAttributes || "{}"),
						};
					});
					dispatch({
						type: SEARCH_RECEIVE_SEARCH_LIST,
						stateId,
						searches: parsedSearches,
					});
				})
				.catch((error, json) => {
					console.log(json);
					console.error(error);
				});
		});
	};
}

const getDefaultSearch = (searchList, searchType, project) => {
	return searchList.find((x) => {
		return (
			x.searchType === searchType &&
			x.additionalAttributes?.isDefault === true &&
			x.project === project
		);
	});
};

// Fetch user searches
export const fetchUserSearches = (params) => {
	const {
		userId,
		stateId,
		selectSearch,
		updateResults,
		setComparableSearches,
		roundUp,
		roundDown,
	} = params;
	return (dispatch, getState) => {
		const { api } = getState().login;
		const { noUserSearches, defaultSearchTranslationEnabled, defaultSearchTranslationLanguages } = getState().projectConfig;
		const defAdditionalAttribs = {
			timeStart: "now-6M/d",
			timeEnd: "now",
			isDefault: false,
			translate: defaultSearchTranslationEnabled,
			translateFull: true,
			translateLangs: defaultSearchTranslationLanguages,
		};
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			if (!noUserSearches) {
				return fetch(`${api.userSearches}/${userId}`, {
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				})
					.then((response) => response.json())
					.then((json) => {
						// REVISIT JA: API is returning search's additionalAttributes property
						// as a string which is not in JSON format so we hack it here to turn
						// it into a usable object, we should really fix the API for this
						const parsedSearches =
							json.payload &&
							json.payload.map((x) => {
								const hasAdditionalAttribs = x.additionalAttributes?.length > 0;
								try {
									const hackedAttribString = !hasAdditionalAttribs
										? ""
										: x.additionalAttributes
												.replace(/(timeStart=)([^,^}]*)/g, "$1" + '"$2"')
												.replace(/(timeEnd=)([^,^}]*)/g, "$1" + '"$2"')
												.replace(/(translateLangs=)([^ ^}]*)/g, "$1" + '"$2"')
												.replace(/{/g, '{"')
												.replace(/, /g, ', "')
												.replace(/=/g, '": ');
									const additionalAttribs = hasAdditionalAttribs
										? JSON.parse(hackedAttribString)
										: defAdditionalAttribs;
									additionalAttribs.timeStart =
										additionalAttribs.timeStart || defAdditionalAttribs.timeStart;
									additionalAttribs.timeEnd =
										additionalAttribs.timeEnd || defAdditionalAttribs.timeEnd;
									additionalAttribs.translateLangs =
										additionalAttribs.translateLangs?.split(",").filter(x => x.trim().length > 0) ||
										defAdditionalAttribs.translateLangs;
									additionalAttribs.translate =
										additionalAttribs.translate !== undefined
											? additionalAttribs.translate
											: defAdditionalAttribs.translate;
									additionalAttribs.translateFull =
										additionalAttribs.translateFull !== undefined
											? additionalAttribs.translateFull
											: defAdditionalAttribs.translateFull;
									return {
										...x,
										additionalAttributes: additionalAttribs,
										query: allQuotesDoubleTemporary(x.query),
									};
								} catch {
									return {
										...x,
										additionalAttributes: defAdditionalAttribs,
										query: allQuotesDoubleTemporary(x.query),
									};
								}
							});
						// Store the received user searches
						dispatch({
							type: SEARCH_RECEIVE_USER_SEARCHES,
							stateId,
							searches: parsedSearches,
							key: api.key,
						});
						// Apply the default search (if one exists)
						const { searches } = getState().search[stateId];
						if (searches) {
							const defaultSearch = getDefaultSearch(parsedSearches, stateId, api.key);
							if (defaultSearch) {
								dispatch(selectSearch(stateId, defaultSearch, roundUp, roundDown));
								if (updateResults) {
									dispatch(updateResults());
								}
							}
							if (setComparableSearches) {
								dispatch(setComparableSearches(defaultSearch));
							}
						}
					})
					.catch((error) => {
						console.error("fetchUserSearches error", error);
					});
			}
		});
	};
};

// Delete user search
export const deleteUserCreatedSearch = (params) => {
	const { id, userId, stateId } = params;

	return (dispatch, getState) => {
		const { api } = getState().login;
		dispatch({
			type: SEARCH_PROACTIVELY_DELETE_USER_CREATED_SEARCH,
			stateId,
			search: params,
		});
		dispatch({
			type: SEARCH_CLOSE_DELETE_SEARCH_MODAL,
			stateId,
		});
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.userSearches}`, {
				method: "DELETE",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
				body: JSON.stringify({
					userId,
					id,
				}),
			})
				.then((response) => response.json())
				.then((json) => {
					// No action required
				})
				.catch((error) => {
					console.error("deleteUserCreatedSearch error", error);
					dispatch({
						type: SEARCH_ADD_USER_CREATED_SEARCH,
						stateId: searchType,
						search: params,
					});
				});
		});
	};
};

// Save user search
const processSavedSearchResponse = (params) => {
	const {
		dispatch,
		json,
		search,
		searchType,
		editingActiveSearch,
		isNewSearch,
		activeSearchObj,
		roundUp,
		roundDown,
	} = params;

	const newSearch = {
		id: json ? json.id : "failedId",
		locationStr: search.locationStr,
		name: search.name,
		project: search.project,
		query: allQuotesDoubleTemporary(search.query),
		searchType,
		userId: search.userId,
		additionalAttributes: search.additionalAttributes,
	};

	dispatch({
		type: SEARCH_ADD_USER_CREATED_SEARCH,
		stateId: searchType,
		search: newSearch,
	});

	if (editingActiveSearch || isNewSearch) {
		const newActiveSearch = activeSearchObj.query ? activeSearchObj.query : newSearch.query; // keep old activesearch as we wont re-execute a search now
		dispatch({
			type: SEARCH_SET_ACTIVE_SEARCH,
			stateId: searchType,
			searchObj: newSearch,
			activeSearch: newActiveSearch,
			roundUp,
			roundDown,
		});
		dispatch({
			type: SEARCH_UPDATE_SEARCH_INPUT,
			stateId: searchType,
			value: newSearch.query,
		});
	}

	dispatch({
		type: SEARCH_SAVE_USER_SEARCH_SUCCESS,
		stateId: searchType,
	});

	setTimeout(() => {
		dispatch({
			type: SEARCH_CLOSE_CREATE_SEARCH_MODAL,
			stateId: searchType,
		});
	}, 1000);
};

export const saveUserSearch = (params) => {
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const {
			createSearchLocation,
			isDefault,
			createSearchTimeStart,
			createSearchTimeEnd,
			createSearchName,
			createSearchQuery,
			editingUserSearch,
			roundUp,
			roundDown,
			searchType,
			translate = undefined,
			translateFull = undefined,
			translateLangs = undefined,
		} = params;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const userId = `${userName}_${userPool}`;
		const { activeSearchObj } = getState().search[searchType];

		dispatch({ type: SEARCH_SAVE_USER_SEARCH_SPINNER });

		const editingActiveSearch = activeSearchObj.id === editingUserSearch;
		const isNewSearch = activeSearchObj.id === "custom";
		const search = {
			userId,
			query: allQuotesSingle(createSearchQuery),
			name: createSearchName,
			locationStr: createSearchLocation || "none",
			project: api.key,
			searchType,
			additionalAttributes: {
				isDefault: isDefault || false,
				timeStart: createSearchTimeStart,
				timeEnd: createSearchTimeEnd,
				translate,
				translateFull,
				translateLangs: translateLangs ? translateLangs.toString() : undefined,
			},
			global: false, // this can't be null, must be an actual boolean
		};
		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.userSearches}`, {
				method: "POST",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
				body: JSON.stringify(search),
			})
				.then((response) => response.json())
				.then((json) => {
					// Update the newly saved search
					processSavedSearchResponse({
						dispatch,
						json,
						search: {
							...search,
							additionalAttributes: {
								...search.additionalAttributes,
								translateLangs: translateLangs,
							},
						},
						searchType,
						editingActiveSearch,
						isNewSearch,
						activeSearchObj,
						roundUp,
						roundDown,
					});
					// If this isn't a brand new search, delete the old one
					if (editingUserSearch) {
						dispatch(deleteUserCreatedSearch({ id: editingUserSearch, userId, stateId: searchType }));
					}
				})
				.catch((error) => {
					console.error("saveUserCreatedSearch error", error);
					dispatch({
						type: SEARCH_SAVE_USER_SEARCH_ERROR,
						stateId: searchType,
						createSearchSpinner: false,
						saveUserSearchError: true,
					});
				});
		});
	};
};

// Search Query Expansion
let queryExpansionAbortController;
const abortQueryExpansion = () => {
	if (queryExpansionAbortController) {
		queryExpansionAbortController.abort();
	}
};

const doFetchQueryExpansion = (params) => {
	const {
		dispatch,
		getState,
		queryString,
		actionId,
		loadingActionId,
		languages,
		stateId,
		translationEnabled,
		fullTranslationEnabled,
		onSuccess,
		setActiveOnSuccess,
	} = params;
	const { api } = getState().login;
	const errorStr = "<unable to expand query>";

	// Cant expand an empty query so just set it to a single wildcard string instead
	if (!queryString || queryString.trim().length === 0) {
		dispatch({ type: actionId, stateId, value: "*" });
		if (setActiveOnSuccess) {
			dispatch({ type: SEARCH_SET_ACTIVE_EXPANDED_QUERY, stateId, value: "*"});
		}
		if (onSuccess) {
			onSuccess();
		}
		return;
	}

	// Set the loading state of the acive expanded query if this request will result in a change to it
	if (setActiveOnSuccess) {
		dispatch({ type: SEARCH_SET_ACTIVE_EXPANDED_QUERY_LOADING, stateId, value: true });
	}

	// Set the loading state of the expanded query
	dispatch({type: loadingActionId, stateId});

	// Get / Refresh tokens	& retreive the expanded query from the API
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { expandedQueryLoading } = getState().search[stateId];
		if (expandedQueryLoading) {
			abortQueryExpansion();
		}
		queryExpansionAbortController = new AbortController();
		return fetch(`${api.queryExpansion}`, {
			method: "POST",
			mode: "cors",
			signal: queryExpansionAbortController.signal,
			body: JSON.stringify({
				query: queryString,
				translate_to: !translationEnabled ? [] : languages,
				additional_translations: fullTranslationEnabled ? true : false,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: actionId,
					stateId,
					value: json.translated_query,
					error: json.error,
					warning: json.warning,
				});
				if (json.error) {
					dispatch({ type: SEARCH_SET_ACTIVE_EXPANDED_QUERY_LOADING, stateId, value: false });
				}
				else {
					if (setActiveOnSuccess) {
						dispatch({ type: SEARCH_SET_ACTIVE_EXPANDED_QUERY, stateId, value: json.translated_query });
					}
					if (onSuccess) {
						onSuccess();
					}
				}
			})
			.catch((error, json) => {
				if (error.name === "AbortError") {
					// No action needed
				} else {
					console.error(error, json);
					dispatch({
						type: actionId,
						stateId,
						error: errorStr,
					});
					dispatch({ type: SEARCH_SET_ACTIVE_EXPANDED_QUERY_LOADING, stateId, value: false });
				}
			});
	});
};

let queryExpandDebounceTimer;
const queryExpandDebouneDelay = 1000;
export const fetchQueryExpansion = (params) => {
	return (dispatch, getState) => {
		clearTimeout(queryExpandDebounceTimer);
		if (params.disableDebounce) {
			doFetchQueryExpansion({ ...params, dispatch, getState });
		} else {
			queryExpandDebounceTimer = setTimeout(() => {
				doFetchQueryExpansion({ ...params, dispatch, getState });
			}, queryExpandDebouneDelay);
		}
	};
};

// ------------ Filters -------------

// Fetch All filters
const filterAbortControllers = {};
const abortFiltersFetch = (stateId) => {
	if (filterAbortControllers[stateId]) {
		filterAbortControllers[stateId].abort();
		delete filterAbortControllers[stateId];
	}
};

export const fetchFilters = (stateId, datasetId) => {
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const { currentDatasetId } = getState().dataExplorer;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		dispatch({
			type: SEARCH_FETCHING_FILTERS,
			stateId,
		});

		let projectId = api.key;
		switch (stateId) {
			case SEARCH_STATE_IDS.EXPLORER:
				projectId = `bfdab55f438bcad35974889ee35d83be_${datasetId || currentDatasetId}`;
				break;
			case SEARCH_STATE_IDS.CONNECTOR:
				projectId = `bfdab55f438bcad35974889ee35d83be_allFilters`;
				break;
			default:
				projectId = api.key;
				break;
		}

		// Get / Refresh tokens		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			const { filtersLoading, filtersRetryCount } = getState().search[stateId];
			if (filtersLoading) {
				abortFiltersFetch(stateId);
			}
			filterAbortControllers[stateId] = new AbortController();
			return fetch(`${api.mediaFilters}` + "?staging=wip", {
				method: "POST",
				mode: "cors",
				signal: filterAbortControllers[stateId].signal,
				body: JSON.stringify({
					project: projectId,
					userName,
					userPool,
					user: `${userName}_${userPool}`,
					mediaTab: stateId === SEARCH_STATE_IDS.MEDIA,
					tab: getTabIdFromStateId(stateId),
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(SERVER_ERROR);
					}
					return response.json();
				})
				.then((json) => {
					if (!Array.isArray(json)) {
						const entries = Object.entries(json);
						for (let i = 0; i < entries.length; i++) {
							entries[1].dataset = entries[0];
						}
					}
					let apiFilters = Array.isArray(json) ? json : Object.values(json);
					if (!Array.isArray(apiFilters)) {
						apiFilters = [];
					}
					decorateFilters(apiFilters);
					dispatch({
						type: SEARCH_RECEIVE_FILTERS,
						stateId,
						filters: apiFilters,
					});
					// Get any child filters for dynamic filters which have an initial "open" status
					for (let i = 0; i < apiFilters.length; i++) {
						if (apiFilters[i].type === DYNAMIC_FILTER_TYPE && apiFilters[i].status === "open") {
							dispatch(fetchDynamicFilters(stateId, apiFilters[i]));
						}
					}
					// Set the default entity type selection and get the entity
					// filters list for the default entity filter type
					const entityFilterTypes = {};
					for (let i = 0; i < apiFilters.length; i++) {
						if (apiFilters[i].fieldType === "entity") {
							entityFilterTypes[apiFilters[i].name] = apiFilters[i];
						}
					}
					const entityFilterEntries = Object.entries(entityFilterTypes);
					if (entityFilterEntries.length > 0) {
						const defaultEntityFilterType =
							entityFilterTypes["Organizations Mentioned"] ||
							entityFilterTypes["People Mentioned"] ||
							entityFilterEntries[0][1];
						dispatch({
							type: SEARCH_SET_ENTITY_TYPE,
							stateId,
							entityType: defaultEntityFilterType,
						});
						fetchEntityFilters(stateId, defaultEntityFilterType);
					}
				})
				.catch((error) => {
					if (filterAbortControllers[stateId]) {
						delete filterAbortControllers[stateId];
					}
					if (error.name === "AbortError") {
						// No action needed
					} else if (filtersRetryCount >= FETCH_RETRY_MAX) {
						console.error(error);
						dispatch({ type: SEARCH_RECEIVE_FILTERS_ERROR, stateId });
					} else {
						console.warn(`${error} - Retry attempt ${filtersRetryCount + 1}...`);
						dispatch({ type: SEARCH_RECEIVE_FILTERS_RETRY, stateId });
						dispatch(fetchFilters(stateId, datasetId));
					}
				});
		});
	};
};

// Fetch entity filters / Fetch Dynamic filters common processing
const fetchEntityOrDynamicFilters = (params) => {
	const { 
		stateId, 
		filter, 
		signal, 
		onSuccess, 
		onError, 
		size, 
		queryOverride,
		startTimeOverride,
		endTimeOverride,
		filtersOverride,
		filtersListOverride,
		ignoreFilterFilter=false,
		excludeFiltersOfSameType=false,
	} = params;

	return (dispatch, getState) => {
		const {
			activeSearchTranslationEnabled,
			activeSearchTranslationLanguages,
			activeSearchObj,
			currentFiltersList,
			timeStart,
			timeEnd,
			filters,
		} = getState().search[stateId];
		const { useInternalTranslation } = getState().projectConfig;
		const { selectedGoogleTranslateLang } = getState().expandedContent;

		const { activeNarrative, activeNarrativeData } = getState().base;
		const proposedNarrative =
			stateId === SEARCH_STATE_IDS.COMPARE_LEFT
				? getState().leftCompare.proposedNarrative
				: stateId === SEARCH_STATE_IDS.COMPARE_RIGHT
					? getState().rightCompare.proposedNarrative
					: undefined;
		const { api, userData, userName } = getState().login;

		const userPool = userData && userData.pool && userData.pool.userPoolId;
		const narId =
			activeNarrative.id && activeNarrative.id !== "narratives" ? activeNarrative.id : null;
		const proposedNarId =
			proposedNarrative?.id && proposedNarrative?.id !== "narratives" ? proposedNarrative.id : null;
		const narParent = narId ? activeNarrativeData.parent : null;
		const proposedNarParent = proposedNarId ? proposedNarrative.parent : null;
		const isDataExplorer =
			stateId === SEARCH_STATE_IDS.EXPLORER || stateId === SEARCH_STATE_IDS.CONNECTOR
				? true
				: false;
		const dataset = isDataExplorer
			? filter.dataset || getState().dataExplorer.currentDatasetId
			: undefined;
		const formattedFilters = formatHierarchyFiltersForPost(filtersOverride || filters, dataset);
		const excludeList = excludeFiltersOfSameType ? [filter.id] : [];
		const queryAdds = formatQueryAddsForPost(filtersListOverride || currentFiltersList, dataset, excludeList);
		const queryExcludes = formatQueryExcludesForPost(filtersListOverride || currentFiltersList, dataset, excludeList);
		const query = queryOverride ||
			(activeSearchObj && activeSearchObj.query && activeSearchObj.query.length > 0
				? activeSearchObj.query
				: undefined);

		const fieldSearch =
			filter.filterFilterString && filter.filterFilterString.length > 0 && !ignoreFilterFilter
				? filter.filterFilterString
				: undefined;

		const isNarrativeRequest =
			stateId === SEARCH_STATE_IDS.NARRATIVES ||
			stateId === SEARCH_STATE_IDS.COMPARE_LEFT ||
			stateId === SEARCH_STATE_IDS.COMPARE_RIGHT;

		// Get / Refresh tokens, fetch the filters and process response		
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.dynamicMediaFilters}`, {
				method: "POST",
				signal,
				mode: "cors",
				body: JSON.stringify({
					dataExplorerTab: isDataExplorer,
					endDate: endTimeOverride || timeEnd,
					fieldName: filter.fieldName,
					fieldSearch,
					filters: formattedFilters,
					mediaTab: stateId === SEARCH_STATE_IDS.MEDIA ? true : false,
					narrative: isNarrativeRequest ? proposedNarId || narId : undefined,
					narrativeTab: isNarrativeRequest,
					parent: isNarrativeRequest ? proposedNarParent || narParent : undefined,
					project: api.key,
					dataset,
					query,
					queryExpand: activeSearchTranslationEnabled ? true : false,
					queryExpandLang: activeSearchTranslationEnabled ? activeSearchTranslationLanguages : [],
					queryAdd: queryAdds,
					queryExclude: queryExcludes,
					size: size || MAX_DYNAMIC_FILTERS,
					startDate: startTimeOverride || timeStart,
					tab: getTabIdFromStateId(stateId),
					translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
					translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
					user: `${userName}_${userPool}`,
					userName,
					userPool,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(SERVER_ERROR);
					}
					return response.json();
				})
				.then(onSuccess)
				.catch(onError);
		});
	};
};

// Fetch Media Source Country Filters
let sourceCountryFilterAbortController;
const abortSourceCountryFiltersFetch = () => {
	if (sourceCountryFilterAbortController) {
		sourceCountryFilterAbortController.abort();
	}
};
let allSourceCountryFilterAbortController;
const abortAllSourceCountryFiltersFetch = () => {
	if (allSourceCountryFilterAbortController) {
		allSourceCountryFilterAbortController.abort();
	}
};

export const fetchSourceCountryFilters = (all=false) => {
	const stateId = SEARCH_STATE_IDS.MEDIA;
	return (dispatch, getState) => {
		const { 
			sourceCountryFiltersLoading, 
			allSourceCountryFiltersLoading, 
			sourceCountryFiltersFetchRetryCount,
			allSourceCountryFiltersFetchRetryCount
		} = getState().media;

		if (all && allSourceCountryFiltersLoading) {
			abortAllSourceCountryFiltersFetch() 
		}
		if (!all && sourceCountryFiltersLoading) {
			abortSourceCountryFiltersFetch();
		}
		if (all) {
			allSourceCountryFilterAbortController = new AbortController();
		}
		else {
			sourceCountryFilterAbortController = new AbortController();
		}

		dispatch({
			type: all
				? MEDIA_FETCHING_ALL_SOURCE_COUNTRY_FILTERS
				: MEDIA_FETCHING_SOURCE_COUNTRY_FILTERS
			});

		const onSuccess = (json) => {
			const results = json.data;
			dispatch({
				type: all 
					? MEDIA_RECEIVE_ALL_SOURCE_COUNTRY_FILTERS 
					: MEDIA_RECEIVE_SOURCE_COUNTRY_FILTERS,
				filters: results,
			});
		};

		const onError = (error) => {
			const rc = all 
				? allSourceCountryFiltersFetchRetryCount 
				: sourceCountryFiltersFetchRetryCount;
			if (error.name === "AbortError") {
				// No action needed
			} else if (rc >= FETCH_RETRY_MAX) {
				console.error(error);
				dispatch({ 
					type: all 
						? MEDIA_RECEIVE_ALL_SOURCE_COUNTRY_FILTERS_ERROR 
						: MEDIA_RECEIVE_SOURCE_COUNTRY_FILTERS_ERROR, 
					stateId,
				});
			} else {
				console.warn(`${error} - Retry attempt ${rc + 1}...`);
				dispatch({ 
					type: all
						? MEDIA_RECEIVE_ALL_SOURCE_COUNTRY_FILTERS_RETRY
						: MEDIA_RECEIVE_SOURCE_COUNTRY_FILTERS_RETRY, 
					stateId,
				});
				dispatch(fetchSourceCountryFilters(all));
			}
		};
		return dispatch(
			fetchEntityOrDynamicFilters({
				stateId: stateId, 
				filter: {fieldName: "sourceCountry.keyword"}, 
				signal: all
					? allSourceCountryFilterAbortController.signal
					: sourceCountryFilterAbortController.signal,
				onSuccess, 
				onError,
				size: 500,
				queryOverride: all ? "" : undefined,
				startTimeOverride: all ? 1 : undefined,
				endTimeOverride: all ?  Date.now() : undefined,
				filtersOverride: all ? [] : undefined,
				filtersListOverride: all ? [] : undefined,
				ignoreFilterFilter: true
			})
		);
	}
};

// Fetch entity filters
const entityFilterAbortControllers = {};
const abortEntityFiltersFetch = (stateId) => {
	if (entityFilterAbortControllers[stateId]) {
		entityFilterAbortControllers[stateId].abort();
		delete entityFilterAbortControllers[stateId];
	}
};

export const fetchEntityFilters = (stateId, filter, numToRequest) => {
	return (dispatch, getState) => {
		if (filter) {
			const { entityFiltersLoading, entityFiltersFetchRetryCount } = getState().search[stateId];

			if (entityFiltersLoading) {
				abortEntityFiltersFetch(stateId);
			}
			entityFilterAbortControllers[stateId] = new AbortController();

			dispatch({
				type: SEARCH_FETCHING_ENTITY_FILTERS,
				stateId,
			});

			const onSuccess = (json) => {
				const results = json.data;
				for (let i = 0; i < results.length; i++) {
					results[i].type = DYNAMIC_FILTER_RESULT_TYPE;
					results[i].parent = filter.id;
					results[i].parentId = filter.id;
					results[i].parentDisplayName = filter.name;
				}
				dispatch({
					type: SEARCH_RECEIVE_ENTITY_FILTERS,
					stateId,
					filters: results,
				});
				if (entityFilterAbortControllers[stateId]) {
					delete entityFilterAbortControllers[stateId];
				}
			};

			const onError = (error) => {
				if (entityFilterAbortControllers[stateId]) {
					delete entityFilterAbortControllers[stateId];
				}
				if (error.name === "AbortError") {
					// No action needed
				} else if (entityFiltersFetchRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: SEARCH_RECEIVE_ENTITY_FILTERS_ERROR, stateId });
				} else {
					console.warn(`${error} - Retry attempt ${entityFiltersFetchRetryCount + 1}...`);
					dispatch({ type: SEARCH_RECEIVE_ENTITY_FILTERS_RETRY, stateId });
					dispatch(fetchEntityFilters(stateId, filter, numToRequest));
				}
			};

			return dispatch(
				fetchEntityOrDynamicFilters({
					stateId, 
					filter, 
					signal: entityFilterAbortControllers[stateId].signal,
					onSuccess, 
					onError,
					size: numToRequest || 200,
				})
			);
		}
	};
};

// Fetch Dynamic filters
const dynamicFilterAbortControllers = {};
const abortDynamicFiltersFetch = (filterId) => {
	if (dynamicFilterAbortControllers[filterId]) {
		dynamicFilterAbortControllers[filterId].abort();
		delete dynamicFilterAbortControllers[filterId];
	}
};
export const fetchDynamicFilters = (stateId, filter) => {
	return (dispatch) => {
		if (!filter.fieldName || filter.status !== "open") {
			return () => {};
		}
		if (filter.isLoading) {
			abortDynamicFiltersFetch(filter.id);
		}
		dynamicFilterAbortControllers[filter.id] = new AbortController();

		dispatch({
			type: SEARCH_FETCHING_DYNAMIC_FILTERS,
			stateId,
			parentFilter: filter,
		});

		const onSuccess = (json) => {
			const results = json.data;
			for (let i = 0; i < results.length; i++) {
				results[i].type = DYNAMIC_FILTER_RESULT_TYPE;
				results[i].parent = filter.id;
				results[i].parentId = filter.id;
				results[i].parentDisplayName = filter.name;
				results[i].dataset = filter.dataset;
			}
			dispatch({
				type: SEARCH_RECEIVE_DYNAMIC_FILTERS,
				stateId,
				newChildren: results,
				parentFilter: filter,
			});
			if (dynamicFilterAbortControllers[filter.id]) {
				delete dynamicFilterAbortControllers[filter.id];
			}
		};

		const onError = (error) => {
			if (error.name !== "AbortError") {
				dispatch({
					type: SEARCH_RECEIVE_DYNAMIC_FILTERS_ERROR,
					stateId,
					filter,
				});
			}
			if (dynamicFilterAbortControllers[filter.id]) {
				delete dynamicFilterAbortControllers[filter.id];
			}
		};

		return dispatch(
			fetchEntityOrDynamicFilters({
				stateId,
				filter,
				signal: dynamicFilterAbortControllers[filter.id].signal,
				onSuccess,
				onError,
				excludeFiltersOfSameType: true,
			})
		);
	};
};

// ------------ Social Media Tab -------------

export function fetchSocialMediaData(article) {
	return (dispatch, getState) => {
		const { api } = getState().login;
		const { distractionFreeDeveloperMode } = getState().commonUI;
		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(
				`${api.singleArticle}?id=${article.id}&index=${article.index}&type=${article.type || article.social_type}&project=${api.project}`,
				{
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				}
			)
				.then((response) => response.json())
				.then((json) => {
					json.exoveraId = article.id;
					//json["unsafe"] = false;
					dispatch({
						type: "receiveArticleData",
						data: json,
						narratives: getState().base.flatNarratives,
						id: article.id,
						index: article.index,
						distractionFreeDeveloperMode,
					});
				})
				.catch((error) => {
					console.error(error);
				});
		});
	};
}

// ------------ Reports Tab -------------

export function fetchReports(params) {
	const {
		ascending,
		begin,
		end,
		query,
		searchObj,
		sortBy,
		// useSearchObj,
	} = params;

	return (dispatch, getState) => {
		const { api } = getState().login;
		const queryToSend = query && query.length > 0 ? query : undefined;
		// const { selectedLanguage } = getState().media;
		// const lang = useSearchObj ? searchObj.lang : selectedLanguage;

		dispatch({ type: FETCHING_REPORTS, payload: { reportsLoading: true } });

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(api.getReports, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					asc: ascending,
					debug: searchObj,
					desc: !ascending,
					endDate: end || null,
					// TODO: UNMOCK: THIS
					// project: "politics2020-c4c66e01afca57f4896cd084f0c73df0",
					// query: "climate change",
					project: api.key,
					query: queryToSend,
					searchId: "thisIsAnId", // null breaks the API
					sort: sortBy || "pubdate",
					startDate: begin || null,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: RECEIVE_REPORTS,
						payload: {
							reports: json.articles,
							reportsHaveNeverLoaded: false,
							// articleHeaders: json.headers,
							reportsHeaders: buildTableHeaders({
								headerNames: json.headers,
								options: headerTypes,
								append: [],
							}),
							reportsLoading: false,
						},
					})
				)
				.catch((error, json) => {
					console.log(json);
					console.error(error);
				});
		});
	};
}

// ------------ Crosstabs -------------

export const fetchCrosstabsStats = (params) => {
	const {
		entityString,
		futureDateObject,
		futureEntityFilters,
		futureNarrativeFilters,
		futurePerspective,
		futureTopic,
	} = params;
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const {
			altProjectForCrosstabsNarratives,
			analystSystem,
			configureStats,
			desiredCrosstabsNarrativeOrder,
			crosstabsBargraphTopLeft,
			crosstabsBargraphMiddleTopLeft,
			crosstabsBargraphMiddleLeft,
			crosstabsBargraphMiddleBottomLeft,
			crosstabsBargraphBottomLeft,
			crosstabsBargraphTopRight,
			crosstabsBargraphMiddleRight,
			crosstabsBargraphBottomRight,
			crosstabsNarrativeFacets,
		} = getState().projectConfig;
		const { baselineDateBegin, baselineDateEnd, flatNarratives, relevancy } = getState().base;
		const staging = getState().base.stagingData;
		const {
			currentTopic,
			entity,
			entityFilters,
			narrativeFilters,
			perspective,
			selectedDateRange,
		} = getState().crosstabs;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		// FLAG_ENABLE_MULTIPLE_NARRATIVE_FILTERS - TODO: Probably switch back if re-enabling narrative filters
		// -- switching to currentTopic from narrativeFilters[0] to fix a bug where setting the topic on CrosstabsInit returns All Topics
		const narrative =
			futureTopic || (futureNarrativeFilters ? futureNarrativeFilters[0] : currentTopic);
		// const narrative = futureTopic || (futureNarrativeFilters ? futureNarrativeFilters[0] : narrativeFilters[0]);

		const entityObj = entityString
			? {
					name: entityString,
					id: entityString,
					type: "Persons",
					parent: "keywords",
				}
			: {
					name: entity.name,
					id: entity.id,
					type: entity.type,
					parent: "keywords",
				};
		const entityFiltersForFetch = futureEntityFilters || entityFilters;
		const filters = formatFiltersForPost([...entityFiltersForFetch, entityObj]);
		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.crosstabs}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					ai: aiOnly,
					analystSystem,
					endDate: baselineDateEnd ? baselineDateEnd.toString() : null,
					filters,
					parent: narrative.parent,
					perspective: futurePerspective || perspective,
					narrative: narrative.id,
					relevancy,
					startDate: setStartDate({
						begin: baselineDateBegin,
						rangeObj: futureDateObject || selectedDateRange,
						end: baselineDateEnd,
					}),
					project: altProjectForCrosstabsNarratives || api.key,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(SERVER_ERROR);
					}
					return response.text();
				})
				.then((data) => {
					return data ? JSON.parse(data) : {};
				})
				.then((json) => {
					return dispatch({
						type: RECEIVE_CROSSTABS_STATS,
						stats: json,
						flatNarratives,
						configureStats,
						entityFilters: entityFiltersForFetch,
						// FLAG_ENABLE_MULTIPLE_NARRATIVE_FILTERS - unhack this when the time comes
						narrativeFilters: [narrative],
						desiredCrosstabsNarrativeOrder,
						crosstabsBargraphTopLeft,
						crosstabsBargraphMiddleTopLeft,
						crosstabsBargraphMiddleLeft,
						crosstabsBargraphMiddleBottomLeft,
						crosstabsBargraphBottomLeft,
						crosstabsBargraphTopRight,
						crosstabsBargraphMiddleRight,
						crosstabsBargraphBottomRight,
						crosstabsNarrativeFacets,
					});
				})
				.catch((error, json) => {
					console.error(error, json);
				});
		});
	};
};

export const fetchEntityMapStats = (params) => {
	const {
		entityString,
		futureDateObject,
		futureEntityFilters,
		futureNarrativeFilters,
		futurePerspective,
		futureTopic,
	} = params;
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { altProjectForCrosstabsNarratives, analystSystem } = getState().projectConfig;
		const { baselineDateBegin, baselineDateEnd, relevancy } = getState().base;
		const staging = getState().base.stagingData;
		const { entity, entityFilters, narrativeFilters, perspective, selectedDateRange } =
			getState().crosstabs;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		// FLAG_ENABLE_MULTIPLE_NARRATIVE_FILTERS
		const narrative =
			futureTopic || (futureNarrativeFilters ? futureNarrativeFilters[0] : narrativeFilters[0]);

		const entityObj = entityString
			? {
					name: entityString,
					id: entityString,
					type: "Persons",
					parent: "keywords",
				}
			: {
					name: entity.name,
					id: entity.id,
					type: entity.type,
					parent: "keywords",
				};
		const entityFiltersForFetch = futureEntityFilters || entityFilters;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.map}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					// aggregationType: stateCode ? dmaAggregation ? "dma" : "county" : "state", // state/county/dma
					aggregationType: "state", // state/county/dma
					ai: aiOnly,
					analystSystem,
					endDate: baselineDateEnd ? baselineDateEnd.toString() : null,
					event: false,
					filters: formatFiltersForPost([...entityFiltersForFetch, entityObj]),
					includeCounties: false,
					parent: narrative.parent,
					perspective: futurePerspective || perspective,
					max: 20,
					narrative: narrative.id === "narratives" ? "ALL" : narrative.id,
					relevancy,
					slice: 7,
					startDate: setStartDate({
						begin: baselineDateBegin,
						rangeObj: futureDateObject || selectedDateRange,
						end: baselineDateEnd,
					}),
					// state: stateCode, // required for aggregationType county
					project: altProjectForCrosstabsNarratives || api.key,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: RECEIVE_CROSSTABS_MAP_STATS,
						data: json,
					})
				)
				.catch((error, json) => {
					console.error(error, json);
				});
		});
	};
};

// --- Data Explorer Entities ---
let deEntitiesAbortController;
const abortDEEntitiesFetch = () => {
	if (deEntitiesAbortController) {
		deEntitiesAbortController.abort();
	}
};

export const doFetchDataExplorerEntities = (params) => {
	const { endDate, startDate, fetchKey, filtersList, queryString } = params;
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const dataset = getState().dataExplorer.currentDatasetId;
		const { entitiesFetchingRetryCount } = getState().dataExplorer;
		const { api, userData, userName } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const filtersForAPI = formatFiltersForPost(filtersList);
		const queryAdds = formatQueryAddsForPost(filtersList);

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			const { entitiesFetching } = getState().dataExplorer;
			if (entitiesFetching) {
				abortDEEntitiesFetch();
			}
			deEntitiesAbortController = new AbortController();
			return fetch(`${api.entities}?staging=${staging}`, {
				method: "POST",
				signal: deEntitiesAbortController.signal,
				mode: "cors",
				body: JSON.stringify({
					ai: false,
					analystSystem: false,
					endDate: endDate || Number(moment().add(7, "days").format("x")),
					event: false,
					filters: filtersForAPI,
					query: queryString || "*",
					queryAdds,
					perspective: "Source",
					project: `bfdab55f438bcad35974889ee35d83be_${dataset}`,
					max: 500,
					relevancy: 0.65,
					slice: 15,
					startDate: startDate || Number(moment().subtract(7, "days").format("x")),
					translateEntities: true,
					user: `${userName}_${userPool}`,
					dataExplorerTab: true,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => {
					if (!response.ok) {
						throw new Error(SERVER_ERROR);
					}
					return response.json();
				})
				.then((json) => {
					dispatch({ type: RECEIVE_DATA_EXPLORER_ENTITIES, entities: json, fetchKey });
				})
				.catch((error) => {
					if (error.name === "AbortError") {
						// No action needed
					} else if (entitiesFetchingRetryCount >= FETCH_RETRY_MAX) {
						console.error(error);
						dispatch({ type: RECEIVE_DATA_EXPLORER_ENTITIES_ERROR });
					} else {
						console.warn(`${error} - Retry attempt ${entitiesFetchingRetryCount + 1}...`);
						dispatch({ type: RECEIVE_DATA_EXPLORER_ENTITIES_RETRY });
						dispatch(doFetchDataExplorerEntities(params));
					}
				});
		});
	};
};

export function fetchDataExplorerEntities(parameters) {
	return (dispatch, getState) => {
		dispatch({ type: REQUEST_DATA_EXPLORER_ENTITIES });
		dispatch(doFetchDataExplorerEntities(parameters));
	};
}

export function updateDataExplorerEntities() {
	const fetchKey = `explorerRequest_${Date.now()}`;
	const stateId = SEARCH_STATE_IDS.EXPLORER;

	return (dispatch, getState) => {
		const { activeSearchObj, currentFiltersList, currentZoom } = getState().search[stateId];
		const { explorerShowEntities } = getState().projectConfig;
		const { currentDatasetId } = getState().dataExplorer;
		const showEntities = explorerShowEntities.includes(currentDatasetId);

		if (showEntities) {
			dispatch(
				fetchDataExplorerEntities({
					queryString: activeSearchObj.query,
					filtersList: currentFiltersList,
					endDate: currentZoom.end,
					startDate: currentZoom.begin,
					fetchKey,
				})
			);
		}
	};
}

// -------------- Narrative Modal --------------
// Fetches a single timeseries for the graph tab
export function fetchNarrativeModalTimeseries(parameters) {
	const { narrative, selectedDateRange } = parameters;
	// aiOverride should only exist if loading a share view

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { baselineDateBegin, baselineDateEnd, relevancy } = getState().base;
		const { entity, entityFilters } = getState().crosstabs;
		const { analystSystem } = getState().projectConfig;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const entityObj = {
			name: entity.name,
			id: entity.id,
			type: entity.type,
			parent: "keywords",
		};

		const startDate = setStartDate({
			begin: baselineDateBegin,
			rangeObj: selectedDateRange,
			end: baselineDateEnd,
		});
		const endDate = baselineDateEnd ? baselineDateEnd.toString() : null;

		const params = JSON.stringify({
			// aggregate: 7,
			ai: aiOnly,
			analystSystem,
			chartType: "articleCount",
			endDate,
			event: false,
			narrative: narrative.id,
			parent: narrative && narrative.parent,
			perspective: "Source",
			project: api.key,
			filters: formatFiltersForPost([...entityFilters, entityObj]),
			startDate,
			relevancy,
			user: `${userName}_${userPool}`,
		});

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.timeseries}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: params,
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
					// 'Access-Control-Allow-Origin': '*',
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: RECEIVE_NARRATIVE_MODAL_TIMESERIES,
						data: json,
						// Because API currently ignores startDate and endDate
						endDate,
						startDate,
					})
				)
				.catch((error) => {
					console.error(error);
				});
		});
	};
}

export const fetchNarrativeModalBargraph = (params) => {
	const { selectedDateRange } = params;
	return (dispatch, getState) => {
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const {
			altProjectForCrosstabsNarratives,
			analystSystem,
			crosstabsNarrativeHeaderLabels,
			crosstabsNarrativeHeaders,
			desiredCrosstabsNarrativeOrder,
		} = getState().projectConfig;
		const { baselineDateBegin, baselineDateEnd, relevancy } = getState().base;
		// const staging = getState().base.stagingData;
		const {
			currentNarrativeFacet,
			currentTopic,
			entity,
			entityFilters,
			narrativeModalData,
			perspective,
		} = getState().crosstabs;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const entityObj = {
			name: entity.name,
			id: entity.id,
			type: entity.type,
			parent: "keywords",
		};
		const filters = formatFiltersForPost([...entityFilters, entityObj]);
		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.crosstabs}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					ai: aiOnly,
					analystSystem,
					endDate: baselineDateEnd ? baselineDateEnd.toString() : null,
					event: false,
					filters,
					parent: currentTopic.parent,
					perspective,
					max: 20,
					narrative: currentTopic.id,
					relevancy,
					slice: 15,
					startDate: setStartDate({
						begin: baselineDateBegin,
						rangeObj: selectedDateRange,
						end: baselineDateEnd,
					}),
					project: altProjectForCrosstabsNarratives || api.key,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) =>
					dispatch({
						type: RECEIVE_NARRATIVE_MODAL_BARGRAPH,
						barGraph: formatNarrativeBarGraph({
							crosstabsNarrativeHeaders,
							currentNarrativeFacet,
							desiredOrder: desiredCrosstabsNarrativeOrder,
							labels: crosstabsNarrativeHeaderLabels,
							narrativeData: json && json.narratives && json.narratives[narrativeModalData.id],
						}),
					})
				)
				.catch((error, json) => {
					console.error(error, json);
				});
		});
	};
};

// ----------------------------------------------------------------------



// Directly downloads the API response
export function exportContent(parameters) {
	const {
		adjustForAggregation = false,
		ascending,
		contentFilteredByDate,
		endDate,
		filters,
		narrative,
		perspective,
		sortBy,
		startDate,
	} = parameters;

	return (dispatch, getState) => {
		const { relevancy, stagingData } = getState().base;
		const { aggregationLevel } = getState().base;
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { analystSystem, useInternalTranslation } = getState().projectConfig;
		const { selectedGoogleTranslateLang } = getState().expandedContent;
		const narrativeId = narrative.parent === "self" ? undefined : narrative.id;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		dispatch({ type: "disableExportButton" });

		const filteredStartDate = contentFilteredByDate
			? Number(contentFilteredByDate.begin)
			: startDate;
		const adjustedStartDate = adjustForAggregation
			? adjustStartDateForAggregation({ filteredStartDate, aggregationLevel }).toString()
			: filteredStartDate;
		const adjustedEndDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : endDate;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.articles}?staging=${stagingData}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					analystSystem,
					startDate: adjustedStartDate,
					endDate: adjustedEndDate,
					event: isThisAnEvent({ id: narrative.id, events: getState().events.eventTypes }),
					// slice: 15,
					narrative: narrativeId,
					perspective,
					outputType: "export",
					outputFormat: "csv",
					project: api.key,
					filters: formatFiltersForPost(filters),
					parent: narrative.parent,
					sort: [sortBy],
					asc: ascending,
					desc: !ascending,
					ai: aiOnly,
					relevancy,
					translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
					translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					// "Content-Type": "application/json",
					"Content-Type": "application/csv",
					Authorization: idToken,
				},
				responseType: "blob",
			})
				.then((response) => response.blob())
				.then((csv) => {
					const formattedFileName = narrative.name || new Date().toISOString();
					download(csv, `${formattedFileName}.csv`, "application/csv");
					dispatch({ type: "enableExportButton" });
				})
				.catch((error) => {
					console.error(error);
					dispatch({ type: "showExportError" });
					dispatch({ type: "enableExportButton" });
					setTimeout(() => {
						dispatch({ type: "clearExportError" });
					}, 8000);
				});
		});
	};
}

// Directly downloads the API response
export function exportContentCompare(parameters) {
	const {
		adjustForAggregation = false,
		ascending,
		contentFilteredByDate,
		endDate,
		filters,
		narrative,
		perspective,
		side,
		sortBy,
		startDate,
	} = parameters;

	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName } = getState().login;
		const { aiOnly } = getState().commonUI;
		const { aggregationLevel } = side === "Left" ? getState().leftCompare : getState().rightCompare;
		const { analystSystem, useInternalTranslation } = getState().projectConfig;
		const { selectedGoogleTranslateLang } = getState().expandedContent;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		dispatch({ type: `disableExportButton${side}` });
		const narrativeId = narrative.parent === "self" ? undefined : narrative.id;

		const filteredStartDate = contentFilteredByDate
			? Number(contentFilteredByDate.begin)
			: startDate;
		const adjustedStartDate = adjustForAggregation
			? adjustStartDateForAggregation({ filteredStartDate, aggregationLevel }).toString()
			: filteredStartDate;
		const adjustedEndDate = contentFilteredByDate ? Number(contentFilteredByDate.end) : endDate;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.articles}?staging=${staging}`, {
				method: "POST",
				mode: "cors",
				body: JSON.stringify({
					analystSystem,
					startDate: adjustedStartDate,
					endDate: adjustedEndDate,
					event: isThisAnEvent({ id: narrativeId, events: getState().events.eventTypes }),
					// slice: 15,
					narrative: narrativeId,
					perspective,
					outputType: "export",
					outputFormat: "csv",
					project: api.key,
					filters: formatFiltersForPost(filters),
					parent: narrative.parent,
					sort: [sortBy],
					asc: ascending,
					desc: !ascending,
					ai: aiOnly,
					translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
					translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,
					user: `${userName}_${userPool}`,
				}),
				headers: {
					// "Content-Type": "application/json",
					"Content-Type": "application/csv",
					Authorization: idToken,
				},
				responseType: "blob",
			})
				.then((response) => response.blob())
				.then((csv) => {
					const formattedFileName = narrative.name || new Date().toISOString();
					download(csv, `${formattedFileName}.csv`, "application/csv");
					dispatch({ type: `enableExportButton${side}` });
				})
				.catch((error) => {
					console.error(error);
					dispatch({ type: `showExportError${side}` });
					dispatch({ type: `enableExportButton${side}` });
					setTimeout(() => {
						dispatch({ type: `clearExportError${side}` });
					}, 8000);
				});
		});
	};
}

export function checkNotifications(clearedNotifications) {
	return (dispatch, getState) => {
		const staging = getState().base.stagingData;
		const { api, userData, userName } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;
		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			if (api.notifications) {
				return fetch(`${api.notifications}?staging=${staging}`, {
					method: "POST",
					mode: "cors",
					body: JSON.stringify({
						project: api.key,
						user: `${userName}_${userPool}`,
					}),
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				})
					.then((response) => response.json())
					.then((json) =>
						dispatch({
							type: "receiveNotificaitons",
							data: json,
							clearedNotifications,
						})
					)
					.catch((error) => {
						console.error(error);
					});
			}
		});
	};
}

export function translateArticle(params) {
	const { sourceLang, targetLang, text, textType } = params;
	return (dispatch) => {
		return fetch(
			`https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${encodeURI(text)}`,
			{
				method: "GET",
			}
		)
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: "receiveTranslation",
					data: json,
					textType,
				})
			)
			.catch((error) => {
				dispatch({
					type: "translationError",
					error,
				});
			});
	};
}

// FLAG_ATTEMPTING_TO_TRANSLATE_MISSING_TRANSCRIPTS
export function translateTranscript({ data, index, callsRequired }) {
	const { lang, transcriptHtml } = data;
	const sourceLang = langCodeLookup(lang);
	const targetLang = "en";

	// const textArray = [];
	// const startIndex = index * 50;
	// const segmentSlice = transcriptJson.segments.slice(startIndex, startIndex + 50);
	// const textString = JSON.stringify(segmentSlice);
	// const textString = JSON.stringify(transcriptJson.segments);

	// _.each(segmentSlice, (textObj) => {
	// 	textArray.push(textObj.text);
	// });

	return (dispatch) => {
		return fetch(
			`https://translate.googleapis.com/translate_a/single?client=gtx&sl=${sourceLang}&tl=${targetLang}&dt=t&q=${transcriptHtml}`,
			{
				method: "GET",
			}
		)
			.then((response) => response.json())
			.then((json) =>
				dispatch({
					type: ADD_TRANSLATION_TO_TRANSCRIPTS,
					data: json,
					// segments: segmentSlice,
					// startIndex,
					// callsRequired,
				})
			)
			.catch((error) => console.error(error));
	};
}

// ------------- Email subscription ------------

export function getUserSubscriptions() {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.emailSubscribe}?email=${userEmail}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					dispatch({
						type: RECEIVE_USER_SUBSCRIPTIONS,
						subscriptions: json || [],
					});
				})
				.catch((error) => {
					// dispatch({
					// 	type: "getUserSubscriptionsError",
					// 	error,
					// })
					console.error("Error in getUserSubscriptions fetch", error);
				});
		});
	};
}

export function subscribeToEmail() {
	return (dispatch, getState) => {
		const { api, userEmail, emailSubscriptions } = getState().login;
		const { emailSubscribeOption } = getState().projectConfig;

		// // MOCKED:
		// dispatch({
		// 	type: "subscribeToEmailSuccess",
		// 	subscriptions: addOrRemoveString(emailSubscriptions, currentProject),
		// })

		// UNMOCK: - (this is the unmocked version)
		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(api.emailSubscribe, {
				method: "POST",
				body: JSON.stringify({
					email: userEmail,
					lists: addOrRemoveString(emailSubscriptions, emailSubscribeOption),
				}),
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) =>
					// NOTE: May want to do this manually
					dispatch({
						type: "subscribeToEmailSuccess",
						response: json,
					})
				)
				.catch((error) => {
					dispatch({
						type: "subscribeToEmailError",
						error,
					});
					console.error("Error in subscribeToEmail fetch", error);
				});
		});
	};
}

// -------- Share feature -------

export function saveShare(params) {
	return (dispatch, getState) => {
		const {
			// contentSingleArticleId,
			position,
		} = params;
		const { api, currentProject, userData, userName } = getState().login;
		const { location } = getState().router;
		const {
			activeNarrativeData,
			activeRelevancy,
			contentFilteredByDate,
			contentHeaderSortTypeSource,
			contentHeaderSortTypeAudience,
			contentHeaderSortAscendingSource,
			contentHeaderSortAscendingAudience,
			currentZoom,
			perspective,
			filtersList,
			entityFilters,
			activeKeywords,
			mapHighlightId,
			stagingData,
		} = getState().base;
		const { aiOnly } = getState().commonUI;
		const { lines } = getState().graphTab;
		const { expandedContentId, expandedContentIndex } = getState().expandedContent;
		const { activeContentTabFilters, currentContentTab, dateStart, dateEnd } =
			getState().contentTab;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		const graphMode = location && location.pathname === "/graph";
		const curatedMode = location && location.pathname === "/curated";
		const narrativesMode =
			(location && location.pathname === "/narratives") || location.pathname === "/compare";
		const mediaMode = location && location.pathname === "/media";
		const tabSlug =
			location && location.pathname
				? location.pathname.replace(/^\//, "").replace("compare", "narratives")
				: "";

		// Set the sort variables by perspective
		const contentHeaderSortType =
			perspective === "Source" ? contentHeaderSortTypeSource : contentHeaderSortTypeAudience;
		const contentHeaderSortAscending =
			perspective === "Source"
				? contentHeaderSortAscendingSource
				: contentHeaderSortAscendingAudience;

		// Declare view specific variables
		let narrativeTab = {};
		let contentTab = {};
		let mediaTab = {};
		const graphTabLineIdArr = [];

		// Assign data based on the current view
		if (graphMode) {
			_.each(lines, (line) => {
				graphTabLineIdArr.push({
					id: line.id,
					filtersList: line.filters,
					perspective: line.perspective,
					parent: line.parent,
					info: line.info,
					name: line.name,
					optimalLag: line.optimalLag,
					predictiveVal: line.predictiveVal,
					type: line.type,
				});
			});
		} else if (curatedMode) {
			contentTab = {
				filters: activeContentTabFilters,
				dateStart,
				dateEnd,
				currentTab: currentContentTab,
				// contentSingleArticleId,
				expandedContentId,
				expandedContentIndex,
			};
		} else if (narrativesMode) {
			narrativeTab = {
				activeNarrativeData: cloneObjectWithout({
					obj: activeNarrativeData,
					withoutArr: ["timeseries", "weeklyTimeseries", "monthlyTimeseries", "query", "info"],
				}),
				activeRelevancy,
				contentFilteredByDate,
				contentHeaderSortAscending,
				contentHeaderSortType,
				currentZoom,
				expandedContentId,
				expandedContentIndex,
				perspective,
				activeFilters: filtersList,
				entityFilters,
				activeKeywords,
				mapHighlightId,
			};
		} else if (mediaMode) {
			mediaTab = {
				expandedContentId,
				expandedContentIndex,
			};
		}

		// // hack smash mock
		// _.each(narrativeTab.activeNarrativeData.children, (child) => {
		// 	child.header = null;
		// });

		// Including children sometimes causes dynamo error, and they aren't necessary
		if (narrativeTab.activeNarrativeData && narrativeTab.activeNarrativeData.children) {
			narrativeTab.activeNarrativeData.children = [];
		}

		const shareDataObj = {
			aiOnly,
			contentTab,
			graphTabLineIdArr,
			mediaTab,
			navMode: tabSlug,
			narrativeTab,
			projectId: currentProject,
			stagingData,
		};
		const shareData = JSON.stringify(shareDataObj);

		// const routeId = md5(JSON.stringify(shareData));
		// // dispatch({ type: "displayShareLink", routeId, position });
		
		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.save}`, {
				method: "POST",
				body: JSON.stringify({
					// routeId,
					userName,
					userPool,
					shareData,
				}),
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					if (_.isEmpty(json.body)) {
						dispatch({
							type: "displayShareLink",
							response: json,
							position,
						});
					} else {
						dispatch({
							type: "displayShareLinkError",
							response: json,
							position,
						});
					}
				})
				.catch((error) => {
					console.error("saveShare error =>", error);
				});
		});
	};
}

export function loadShareData(params) {
	const { shareId } = params;
	return (dispatch, getState) => {
		const { api, availableProjects, currentProject, userName } = getState().login;
		const { activeConfigs } = getState().chat;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.save}/${shareId}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					if (json) {
						const shareData = JSON.parse(json.shareData);
						const { aiOverride, contentTab, mediaTab, narrativeTab, navMode, projectId } = shareData;
						const baseURL = window.location.href.split("?")[0];
						const currentProjectCorrect = currentProject === projectId;
						const userHasAccessToThisProject = _.find(availableProjects, (project) => {
							return project.id === projectId;
						});

						// // Make sure the user has access
						if (userHasAccessToThisProject) {
							// Set correct project here - NOTE: this will cause a refresh and loadShareData
							// to be called again upon next mount of the Setup component
							if (!currentProjectCorrect) {
								dispatch(setProject(userHasAccessToThisProject, userName, false));
								return;
							}

							// Clean up URL - NOTE: this must happen after the project changes.
							window.history.pushState({}, document.title, baseURL);

							// seed data that doesn't need a secondary fetch
							dispatch({
								type: "loadShareData",
								data: json,
							});

							// Graph tab data fetch
							if (api.listTimeseries) {
								dispatch(fetchTimeseriesList({ aiOverride }));
								dispatch(fetchGraphTabFilterOptions({ aiOverride })); // get available filter types
							}

							// fetch data depending on the tab
							if (navMode === GRAPH_ROUTE) {
								dispatch({ type: "graphNavigation" });
								_.each(json.graphTabLineIdArr, (line) => {
									dispatch({ type: "graphNavigation" });
									dispatch(
										fetchGraphTabTimeseries({
											narrative: line,
											perspective: line.perspective,
											filtersList: line.filtersList,
											aiOverride,
										})
									);
								});
								if (api.narratives) {
									dispatch(fetchTrends()); // load base narratives
								}
							} else if (navMode === MEDIA_ROUTE) {
								const { expandedContentId, expandedContentIndex } = mediaTab;
								if (expandedContentId) {
									dispatch(
										fetchArticleData({
											id: expandedContentId,
											nav: navMode,
											index: expandedContentIndex,
										})
									);
									if (!activeConfigs["single"]) {
										dispatch(setActiveChatConfig("single", {dataset: DATASET_ID_MEDIA}));
									}
									dispatch({ type: "openContentModal" });
								}
							} else if (navMode === CURATED_ROUTE) {
								const { expandedContentId, expandedContentIndex } = contentTab;
								dispatch({ type: CONTENT_NAVIGATION });
								// Content tab data fetch
								if (api.content && api.contentFilters) {
									dispatch(fetchContentFilters({ aiOverride }));
									dispatch(
										fetchContentArticles({
											filters: contentTab.filters,
											dateStart: contentTab.dateStart,
											dateEnd: contentTab.dateEnd,
											aiOverride,
											share: true,
											// shareSingleArticleId: contentTab.contentSingleArticleId,
										})
									);
									if (expandedContentId) {
										dispatch(
											fetchArticleData({
												id: expandedContentId,
												nav: navMode,
												index: expandedContentIndex,
											})
										);
										if (!activeConfigs["single"]) {
											dispatch(setActiveChatConfig("single", {dataset: DATASET_ID_CURATED}));
										}
										dispatch({ type: "openContentModal" });
									}
								}
								if (api.narratives) {
									dispatch(fetchTrends()); // load base narratives
								}
								if (contentTab.currentTab) {
									dispatch({ type: "setDefaultTab", defaultTab: contentTab.currentTab });
								}
							} else if (navMode === "narratives") {
								dispatch({ type: "narrativeNavigation" });
								const {
									activeFilters,
									activeKeywords,
									activeNarrativeData,
									activeRelevancy,
									contentHeaderSortAscending,
									contentHeaderSortType,
									contentFilteredByDate,
									currentZoom,
									entityFilters,
									expandedContentId,
									expandedContentIndex,
									mapHighlightId,
									perspective,
								} = narrativeTab;
								// Set content sort, before the data is fetched
								if (contentHeaderSortType) {
									// Should always be true for new shares
									dispatch({
										type: "setContentSort",
										sortBy: contentHeaderSortType,
										ascending: contentHeaderSortAscending,
										perspective,
									});
								}
								// Set them all to a custom date range
								currentZoom.name = "Custom";
								// dispatch({
								// 	type: SYNC_RELEVANCY,
								// 	payload: { relevancy: activeRelevancy, activeRelevancy },
								// });
								// REVISIT JA: graph and article list are not loading correctly fetchTrends needs to be replaced
								// here with something more specific (i.e. that will not reset all state) to resolve this
								// dispatch(
								// 	fetchTrends({
								// 		activeFilters,
								// 		activeNarrativeData,
								// 		contentFilteredByDate,
								// 		currentZoom,
								// 		entityFilters,
								// 		keywords: activeKeywords,
								// 		mapHighlightId,
								// 		perspective,
								// 		relevancyOverride: activeRelevancy,
								// 	})
								// );
								dispatch({ type: "setActiveNarrativeFromShare", activeNarrativeData });
								// Set zoom, even if it was on History
								dispatch({ type: SET_CURRENT_ZOOM, currentZoom });
								// Sets the indicator - has to go after SET_CURRENT_ZOOM
								dispatch({ type: FILTER_CONTENT_BY_DATE, contentFilteredByDate });
								// The keywords need to appear in the UI
								dispatch({ type: "setVisibleKeywordsFromSaved", newKeywords: activeKeywords });
								// Open entity filters drawer if we have entity filters
								if (entityFilters && entityFilters.length > 0) {
									dispatch({ type: "openSidebarEntities" });
								}
								if (expandedContentId) {
									dispatch(fetchArticleData({ id: expandedContentId, index: expandedContentIndex }));
									if (!activeConfigs["single"]) {
										dispatch(setActiveChatConfig("single", {dataset: DATASET_ID_NARRATIVES}));
									}
									dispatch({ type: "openContentModal" });
								}
							}
						} else {
							dispatch({ type: "noShareAccessError", url: `${baseURL}?share=${shareId}` });
						}
					} else {
						console.error("No json to load in loadShareData", json);
					}
				})
				.catch((error) => {
					console.error("saveShare error =>", error);
					const baseURL = window.location.href.split("?")[0];
					const varURL = window.location.href.split("?share=")[1];
					window.location.replace(`${baseURL}?sharefail=${varURL}`);
				});
		});
	};
}

// ----- share API -------
// Resource: /share
// HTTP Method: POST  > mapped to PutItem
// HTTP Request Body:
// {
//   "routeId":   "md5",
//   "userName": "string - Cognito user name",
//   "userPool":  "string - Cognito user pool"
//	 "shareData": {
//			aiOnly: boolean, (required)
//			projectId: string - "cbp", "gec", etc (required)
//			navMode: string - "curated", "narratives", "compare", "graph" (required)
//			graphTabLineIdArr: - array of objects:  (required if navMode === "graph")
//				{
//					id: "string - md5 hash", (required)
//					perspective: "source" or "reaction"
//					filtersList: array
//					info: "string",
//					name: "string", (required)
//					optimalLag: null or number,
//					parent: undefined or string,
//					predictiveVal: null or number,
//					type: "string",
//				}
//			contentTab: Object  (required if navMode === "compare")
//				{
//					currentTab: {   (required)
//						name: string - ie, "Table", "List", "Expanded", "Map"
//						id: string - ie, "table", "list", "tile", "map"
//					},
//					contentSingleArticleId: "string - md5" or undefined, // For single article share
//					dateEnd: number - utc date number  (required)
//					dateStart: number - utc date number  (required)
//					filters: array of objects  (required - can be empty)
//					 [
//						{
//							active: true, //  (required) always true
//							color: {  (required)
//								colorblind: "colorblindBroken",
//								dark: "#54c4e2",
//								id: "carolina",
//								light: "#54c4e2",
//							},
//							filterType: undefined or string
//							grandparent: undefined or string
//							icon: undefined or React Component
//							id: string   (required)
//							label: undefined ??? not sure what this is for
//							name: string  (required)
//							parent: undefined or string
//							type: undefined or string
//						},
//				}
// 		}
// }

// // Test:
// {
// 	"userName": "Dude",
//   "userPool": "Test User Pool",
// 	// "shareData": {"aiOnly":false,"contentTab":{"filters":"[{\"active\":true,\"color\":{\"id\":\"carolina\",\"dark\":\"#54c4e2\",\"darkChild\":\"#54c4e2\",\"light\":\"#54c4e2\",\"lightChild\":\"#54c4e2\",\"colorblind\":\"colorblindBroken\"},\"id\":\"guatemala\",\"name\":\"Guatemala\",\"parent\":\"location\"},{\"active\":true,\"color\":{\"id\":\"chartruese\",\"dark\":\"#c2eb3c\",\"darkChild\":\"#c2eb3c\",\"light\":\"#c2eb3c\",\"lightChild\":\"#c2eb3c\",\"colorblind\":false},\"id\":\"el salvador\",\"name\":\"El Salvador\",\"parent\":\"location\"}]","dateStart":"1560297600000","dateEnd":"1565568000000","currentTab":false},"graphTabLineIdArr":[],"navMode":"curated","projectId":"cbp","stagingData":null}
// 	// "shareData": '{"aiOnly":false,"contentTab":{"filters":[],"dateStart":"1560297600000","dateEnd":"1565568000000","currentTab":false},"graphTabLineIdArr":[],"navMode":"curated","projectId":"cbp","stagingData":null}'
// 	"shareData": {"aiOnly":false,"contentTab":{"dateStart":"1560297600000","dateEnd":"1565568000000","currentTab":false},"graphTabLineIdArr":[{"id":"trump-elsalvador","filtersList":[],"perspective":"source","name":"El Salvador - Trump","optimalLag":null,"predictiveVal":null,"type":"cbp"}],"navMode":"graph","projectId":"cbp","stagingData":null}
// }

// // Resource: /share/{routeId}
// // HTTP Method: GET > mapped to Query

// // Integration response template map:
// #set($inputRoot = $input.path('$'))
// {
//     "routeId": "$inputRoot.Item.routeId.S",
//     "userName": "$inputRoot.Item.userName.S",
//     "userPool": "$inputRoot.Item.userPool.S",
//     "shareData": "$inputRoot.Item.shareData.S"
// }

// {
// 	"routeId": "{Item={userPool={S=Test User Pool}, userName={S=Test User Name}, routeId={S=bdbfbed5-bace-11e9-ae5b-0f9aca61697e}, shareData={S={text=Test Share data}}}}",
// }

// bad: Endpoint response body before transformations: {"__type":"com.amazon.coral.service#SerializationException"}
// good: Endpoint response body before transformations: {}

// {
// 	"routeId": "$context.requestId",
// 	"errorMessage": "$context.error.message",
// 	"errorType": "$context.error.responseType",
// 	"errorString": "$context.error.messageString",
// 	"errorValidationString": "$context.error.validationErrorString"
// }

// -------- Entity View-------

// Entity View - EntityData
let entityDataAbortController;
const abortEntityDataFetch = () => {
	if (entityDataAbortController) {
		entityDataAbortController.abort();
	}
};

const doFetchEntityData = (parameters) => {
	const { dispatch, getState, entity } = parameters;
	const { aiOnly } = getState().commonUI;
	const { entityDataFetchCount } = getState().entityView;
	const { api, userEmail } = getState().login;

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { entityDataLoading } = getState().entityView;
		if (entityDataLoading) {
			abortEntityDataFetch();
		}
		entityDataAbortController = new AbortController();
		return fetch(
			`${api.singleArticle}?id=${entity.id}&index=${entity.index}&ai=${aiOnly}&getDoc=unsafe&email=${userEmail}&project=${api.project}`,
			{
				method: "GET",
				signal: entityDataAbortController.signal,
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				const transformedEntity = entityTransformer(json);
				if (transformedEntity.id) {
					dispatch({ type: ENTITY_VIEW_RECEIVE_ENTITY_DATA, data: transformedEntity });
				} else {
					console.error("Invalid entity data returned from API");
					dispatch({ type: ENTITY_VIEW_RECEIVE_ENTITY_DATA_ERROR });
				}
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (entityDataFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: ENTITY_VIEW_RECEIVE_ENTITY_DATA_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${entityDataFetchCount + 1}...`);
					dispatch({ type: ENTITY_VIEW_RECEIVE_ENTITY_DATA_RETRY });
					doFetchEntityData(parameters);
				}
			});
	});
};

export const fetchEntityData = (entity) => {
	return (dispatch, getState) => {
		dispatch({ type: ENTITY_VIEW_FETCH_ENTITY_DATA, entity });
		doFetchEntityData({ dispatch, getState, entity });
	};
};

// Entity View - Relation/Edge Data
let entityRelationDataAbortController;
const abortEntityRelationDataFetch = () => {
	if (entityRelationDataAbortController) {
		entityRelationDataAbortController.abort();
	}
};

const doFetchEntityRelationData = (parameters) => {
	const { dispatch, getState, edge } = parameters;
	const { aiOnly } = getState().commonUI;
	const { entityRelationDataFetchCount } = getState().entityView;
	const { api, userEmail } = getState().login;

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { entityRelationDataLoading } = getState().entityView;
		if (entityRelationDataLoading) {
			abortEntityRelationDataFetch();
		}
		entityRelationDataAbortController = new AbortController();
		return fetch(
			`${api.singleArticle}?id=${edge.id}&index=${edge.index}&ai=${aiOnly}&getDoc=unsafe&email=${userEmail}&project=${api.project}`,
			{
				method: "GET",
				signal: entityRelationDataAbortController.signal,
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				const transformedEdge = edgeTransformer(json);
				dispatch({ type: ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA, data: transformedEdge });
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (entityRelationDataFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${entityRelationDataFetchCount + 1}...`);
					dispatch({ type: ENTITY_VIEW_RECEIVE_ENTITY_RELATION_DATA_RETRY });
					doFetchEntityRelationData(parameters);
				}
			});
	});
};

export const fetchEntityRelationData = (edge) => {
	return (dispatch, getState) => {
		dispatch({ type: ENTITY_VIEW_FETCH_ENTITY_RELATION_DATA, edge });
		doFetchEntityRelationData({ dispatch, getState, edge });
	};
};

// Entity View - Affiliations Graph Data
let entityGraphAbortController;
const abortEntityGraphFetch = () => {
	if (entityGraphAbortController) {
		entityGraphAbortController.abort();
	}
};

const doFetchEntityGraph = (parameters) => {
	const { dispatch, getState, entity, depth } = parameters;
	const { graphDataFetchCount } = getState().entityView;
	const { currentDatasetId } = getState().dataExplorer;
	const { api, userData, userName } = getState().login;
	const userPool = userData && userData.pool && userData.pool.userPoolId;

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { graphDataLoading } = getState().entityView;
		if (graphDataLoading) {
			abortEntityGraphFetch();
		}
		entityGraphAbortController = new AbortController();
		return fetch(`${api.entityGraph}`, {
			method: "POST",
			signal: entityGraphAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				project: api.key,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
				id: entity.id,
				dataset: currentDatasetId,
				recursionLimit: depth,
				edgeLimit: 9999,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				const { edgeMap, nodeMap, graphData } = graphTransformer(json, entity.id);
				dispatch({ type: ENTITY_VIEW_RECEIVE_GRAPH_DATA, data: graphData, edgeMap, nodeMap });
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (graphDataFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: ENTITY_VIEW_RECEIVE_GRAPH_DATA_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${graphDataFetchCount + 1}...`);
					dispatch({ type: ENTITY_VIEW_RECEIVE_GRAPH_DATA_RETRY });
					doFetchEntityGraph(parameters);
				}
			});
	});
};

export const fetchEntityGraph = (entity, depth) => {
	return (dispatch, getState) => {
		dispatch({ type: ENTITY_VIEW_FETCH_GRAPH_DATA });
		doFetchEntityGraph({ dispatch, getState, entity, depth: depth || 3 });
	};
};

// Entity View - Expand Affiliations Graph Data
let expandEntityGraphAbortController;
const abortExpandEntityGraphFetch = () => {
	if (expandEntityGraphAbortController) {
		expandEntityGraphAbortController.abort();
	}
};

const doExpandEntityGraph = (parameters) => {
	const { dispatch, getState, entity, depth, nodeCoords } = parameters;
	const { graphExpandFetchCount, graphEdgeMap, graphNodeMap, graphData } = getState().entityView;
	const { currentDatasetId } = getState().dataExplorer;
	const { api, userData, userName } = getState().login;
	const userPool = userData && userData.pool && userData.pool.userPoolId;

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { graphExpanding } = getState().entityView;
		if (graphExpanding) {
			abortExpandEntityGraphFetch();
		}
		expandEntityGraphAbortController = new AbortController();
		return fetch(`${api.entityGraph}`, {
			method: "POST",
			signal: expandEntityGraphAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				project: api.key,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
				id: entity.id,
				dataset: currentDatasetId,
				recursionLimit: depth,
				edgeLimit: 9999,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				const res = graphExtendTransformer(graphData, graphEdgeMap, graphNodeMap, json, nodeCoords);
				dispatch({
					type: ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA,
					data: res.graphData,
					edgeMap: res.edgeMap,
					nodeMap: res.nodeMap,
					isChanged: res.hasChanges,
					numNodesAdded: res.numNodesAdded,
					numEdgesAdded: res.numEdgesAdded,
				});
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (graphExpandFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${graphExpandFetchCount + 1}...`);
					dispatch({ type: ENTITY_VIEW_RECEIVE_EXPAND_GRAPH_DATA_RETRY });
					doExpandEntityGraph(parameters);
				}
			});
	});
};

export const expandEntityGraph = (entity, depth, nodeCoords) => {
	return (dispatch, getState) => {
		const { graphExpandDepth } = getState().entityView;
		dispatch({ type: ENTITY_VIEW_FETCH_EXPAND_GRAPH_DATA });
		doExpandEntityGraph({
			dispatch,
			getState,
			entity,
			depth: depth || graphExpandDepth,
			nodeCoords,
		});
	};
};

// Entity View - Media Mentions
let entityMediaMentionsAbortController;
const abortEntityMediaMentionsFetch = () => {
	if (entityMediaMentionsAbortController) {
		entityMediaMentionsAbortController.abort();
	}
};

export function doFetchEntityMediaMentions(params) {
	const {
		ascending,
		dispatch,
		entity,
		getState,
		offset,
		pageLength,
		setup,
		sortBy,
		startDate,
		endDate,
	} = params;
	const { api } = getState().login;
	const {
		mediaMentionsFetchCount,
		currentZoom,
		timeSeriesAggregationLevel,
		entityData,
		requestedEntityData,
		contentFilteredByDate,
	} = getState().entityView;	
	const { useInternalTranslation } = getState().projectConfig;
	const { selectedGoogleTranslateLang } = getState().expandedContent;

	// In the current absence of time controls in the entity view we hack a start date here
	// to avoid the default search behavior of only looking over last 7 days
	// const currDate = moment().utcOffset(0);
	// const startDate = currDate.clone().subtract(5, 'years');
	// const startDateNum = startDate.hours(0).minutes(0).seconds(0).milliseconds(0).valueOf();

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { mediaMentionsLoading } = getState().entityView;
		if (mediaMentionsLoading) {
			abortEntityMediaMentionsFetch();
		}
		entityMediaMentionsAbortController = new AbortController();
		return fetch(`${api.getMediaContent}`, {
			method: "POST",
			signal: entityMediaMentionsAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				asc: ascending,
				debug: true,
				desc: !ascending,
				endDate: endDate || currentZoom.end || null,
				entitySearch: [entity?.id || entityData?.id || requestedEntityData?.id],
				entityIndex: entity?.index || entityData?.index || requestedEntityData?.index,
				// index: searchObj.index,
				language: "All",
				project: api.dataKey,
				query: null,
				queryAdd: [],
				queryExclude: [],
				filters: [],
				sort: [sortBy],
				startDate:
					startDate ||
					(contentFilteredByDate
						? adjustStartDateForAggregation({
								startDate: currentZoom.begin,
								aggregationLevel: timeSeriesAggregationLevel,
							})
						: currentZoom.begin) ||
					null,			
				translate: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME,
				translateTo: useInternalTranslation && selectedGoogleTranslateLang.name !== GOOGLE_TRANSLATE_ORIG_LANGUAGE_NAME ? [selectedGoogleTranslateLang.id] : undefined,	
				// type: searchObj.type,
				tab: "mediaTab",
				pageLength,
				offset: offset || 0,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				dispatch({
					type: ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS,
					articles: json.articles,
					headers: json.headers,
					setup: !!setup,
					// fetchKey: `${searchObj.id}_${searchObj.lang || "noLang"}_${searchObj.locationStr || "noLocation"}_${resBegin}to${resEnd}`,
				});
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (mediaMentionsFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${mediaMentionsFetchCount + 1}...`);
					dispatch({ type: ENTITY_VIEW_RECEIVE_MEDIA_MENTIONS_RETRY });
					doFetchEntityMediaMentions(params);
				}
			});
	});
}

export function fetchEntityMediaMentions(params) {
	return (dispatch, getState) => {
		const {
			mediaMentionsPageLength,
			mediaMentionsSortAscending,
			mediaMentionsSortType,
		} = getState().entityView;
		dispatch({ type: ENTITY_VIEW_FETCH_MEDIA_MENTIONS });
		return doFetchEntityMediaMentions({
			...params,
			pageLength: mediaMentionsPageLength,
			sortBy: mediaMentionsSortType,
			ascending: mediaMentionsSortAscending,
			dispatch,
			getState,
		});
	};
}

// Entity View - Timeseries
let entityTimeSeriesAbortController;
const abortEntityTimeSeriesFetch = () => {
	if (entityTimeSeriesAbortController) {
		entityTimeSeriesAbortController.abort();
	}
};

function doFetchEntityTimeSeries(parameters) {
	const { query, lang, locationStr, entity, dispatch, getState } = parameters;

	const { api } = getState().login;
	const {
		activeSearchObj,
		currentZoom,
		timeSeriesRetryCount,
		mediaMentionsPageLength,
		mediaMentionsSortType,
		mediaMentionsSortAscending,
	} = getState().entityView;
	// const formattedFilters = [{ entities: outletFilters.length > 0 ? outletFilters : [] }, { keywords: [query] }];
	// const formattedFilters = formatHierarchyFiltersForPost(filters);
	// const queryAdds = formatQueryAddsForPost(currentFiltersList);
	const queryToSend = query && query.length > 0 ? query : undefined;

	const params = JSON.stringify({
		endDate: currentZoom.end || null,
		entitySearch: [entity.id],
		entityIndex: entity.index,
		project: api.key,
		query: queryToSend,
		startDate: currentZoom.begin || null,
		tab: "mediaTab",
	});

	const id = activeSearchObj?.id;
	const name = activeSearchObj?.name;

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { timeSeriesLoading } = getState().entityView;
		if (timeSeriesLoading) {
			abortEntityTimeSeriesFetch();
		}
		entityTimeSeriesAbortController = new AbortController();
		return fetch(`${api.getMediaTimeseries}`, {
			method: "POST",
			signal: entityTimeSeriesAbortController.signal,
			mode: "cors",
			body: params,
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				json.id = json.id || id;
				json.name = json.name || name;

				const lines = assignStaticColor({ list: [json], colors });
				const keys = Object.keys(lines[0].timeseries);
				const rangeStart = Number(keys[0]);
				const rangeEnd = Number(keys[keys.length - 1]);
				dispatch({
					type: ENTITY_VIEW_RECEIVE_TIME_SERIES,
					lines,
					query,
					fetchKey: `${id}_${lang || "noLang"}_${locationStr || "noLocation"}_${rangeStart}to${rangeEnd}`,
				});
				dispatch(
					fetchEntityMediaMentions({
						ascending: mediaMentionsSortAscending,
						begin: currentZoom.begin,
						end: currentZoom.end,
						entity: entity,
						query: activeSearchObj && activeSearchObj.query,
						searchObj: activeSearchObj,
						sortBy: mediaMentionsSortType,
						pageLength: mediaMentionsPageLength,
						offset: 0,
					})
				);
			})
			.catch((error, json) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (timeSeriesRetryCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: ENTITY_VIEW_RECEIVE_TIME_SERIES_ERROR, data: json });
				} else {
					console.warn(`${error} - Retry attempt ${timeSeriesRetryCount + 1}...`);
					dispatch({ type: ENTITY_VIEW_RECEIVE_TIME_SERIES_RETRY });
					dispatch(doFetchEntityTimeSeries(parameters));
				}
			});
	});
}

export function fetchEntityTimeSeries(params) {
	return (dispatch, getState) => {
		dispatch({ type: ENTITY_VIEW_FETCH_TIME_SERIES });
		return doFetchEntityTimeSeries({
			...params,
			dispatch,
			getState,
		});
	};
}

// Directly downloads the Entity data from the API in the requested file format
export function exportDataAsFile({ url, filename, exportType }) {
	const fileExt = exportType === ENTITY_EXPORT_TYPE_PDF ? ".pdf" : ".zip";
	const fileType = exportType === ENTITY_EXPORT_TYPE_PDF ? "application/pdf" : "application/zip";

	return (dispatch, getState) => {

		dispatch({ type: ENTITY_VIEW_SET_DISABLE_EXPORT_BUTTON, disabled: true });

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(url, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": fileType,
					Authorization: idToken,
				},
				responseType: "blob",
			})
				.then((response) => response.blob())
				.then((f) => {
					const formattedFileName = filename || new Date().toISOString();
					download(f, `${formattedFileName}.${fileExt}`, fileType);
					dispatch({ type: ENTITY_VIEW_SET_DISABLE_EXPORT_BUTTON, disabled: false });
				})
				.catch((error) => {
					console.error(error);
					dispatch({ type: `showExportError` });
					dispatch({ type: ENTITY_VIEW_SET_DISABLE_EXPORT_BUTTON, disabled: false });
					setTimeout(() => {
						dispatch({ type: `clearExportError` });
					}, 8000);
				});
		});
	};
}

// ------------ Help Page -------------

export function fetchUserGuideData() {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;

		// Request the file access link
		dispatch({ type: FETCHING_USER_GUIDE_DATA });
		const index = "exoveraInfo";
		const id = "Exovera_exoINSIGHT_Guide_2.28.24.pdf";

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(
				`${api.singleArticle}?id=${id}&index=${index}&ai=false&getDoc=unsafe&email=${userEmail}&project=${api.project}`,
				{
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				}
			)
				.then((response) => response.json())
				.then((data) => {
					if (data.download_link && data.download_link.length > 0) {
						dispatch({ type: RECEIVE_USER_GUIDE_DATA, data });
					} else {
						dispatch({ type: RECEIVE_USER_GUIDE_DATA_ERROR });
					}
				})
				.catch((error) => {
					console.error(error);
					dispatch({ type: RECEIVE_USER_GUIDE_DATA_ERROR });
				});
		});
	};
}

export function fetchTrainingVideos() {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;

		// Request the file access link
		dispatch({ type: FETCHING_HELP_VIDEO_DATA });
		const index = "training-videos";
		const videoId = "1";

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(
				`${api.singleArticle}?id=${videoId}&index=${index}&ai=false&getDoc=unsafe&email=${userEmail}&project=${api.project}`,
				{
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				}
			)
				.then((response) => response.json())
				.then((json) => {
					const video = json;
					if (video.src && video.src.length > 0) {
						dispatch({ type: RECEIVE_HELP_VIDEO_DATA, videos: [video] });
					} else {
						dispatch({ type: RECEIVE_HELP_VIDEO_DATA_ERROR });
					}
				})
				.catch((error) => {
					console.error(error);
					dispatch({ type: RECEIVE_HELP_VIDEO_DATA_ERROR });
				});
		});
	};
}

export function fetchCatalogData() {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;

		// Fetch the catalog data
		dispatch({ type: FETCHING_CATALOG_DATA });
		const catalogId = "datacatalog";

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			return fetch(`${api.singleArticle}?id=${catalogId}&project=${api.project}&email=${userEmail}`, {
				method: "GET",
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			})
				.then((response) => response.json())
				.then((json) => {
					const catalogData = json;
					if (Array.isArray(catalogData) && catalogData.length > 0) {
						dispatch({ type: RECEIVE_CATALOG_DATA, data: catalogData });
					} else {
						dispatch({ type: RECEIVE_CATALOG_DATA_ERROR });
					}
				})
				.catch((error) => {
					console.error(error);
					dispatch({ type: RECEIVE_CATALOG_DATA_ERROR });
				});
		});
	};
}

// Search Query Expansion
let summarizationAbortController;
export const abortSummarization = () => {
	if (summarizationAbortController) {
		summarizationAbortController.abort();
	}
};

const doFetchSummarization = (params) => {
	const { dispatch, getState, id, index, text, collectionName, urlHash, htmlHash } = params;
	const { api  } = getState().login;
	const errorStr = "Error retreiving summary data";

	// Init state for summarization retreival
	dispatch({ type: INIT_DOCUMENT_SUMMARIZATION });

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		if (summarizationAbortController) {
			abortSummarization();
		}
		summarizationAbortController = new AbortController();
		return fetch(`${api.summarize}`, {
			method: "POST",
			mode: "cors",
			signal: summarizationAbortController.signal,
			body: JSON.stringify({ id, index, collectionName, urlHash, htmlHash, text }),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => response.json())
			.then((json) => {
				dispatch({
					type: RECEIVE_DOCUMENT_SUMMARIZATION,
					data: json,
				});
			})
			.catch((error, json) => {
				if (error.name === "AbortError") {
					// No action needed
				} else {
					dispatch({
						type: RECEIVE_DOCUMENT_SUMMARIZATION_ERROR,
						error: errorStr,
					});
				}
			});
	});
};

export const fetchSummarization = (params) => {
	return (dispatch, getState) => {
		doFetchSummarization({ ...params, dispatch, getState });
	};
};

// Agents
export const createNewAgent = (agentData) => {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;

		const agent = {
			...agentData,
			account: userEmail,
		};

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			if (api.agentsUrl) {
				const apiUrl = api.agentsUrl + `?user=${userEmail}`;

				return fetch(apiUrl, {
					method: "PUT",
					mode: "cors",
					body: JSON.stringify(agent),
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				})
				.then((response) => response.json())
				.then((response) => {
					return response;
				})
				.catch((error) => {
					throw error;
				});
			}
		});
	};
};

export const fetchAgents = () => {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			if (api.agentsUrl) {
				const apiUrl = api.agentsUrl + `?user=${userEmail}`;

				return fetch(apiUrl, {
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				})
				.then((response) => response.json())
				.then((response) => {
					dispatch({
						type: FETCH_AGENTS_SUCCESS,
						payload: response,
					});
					return response;
				})
				.catch((error) => {
					console.error("Fetch Agents Error", error);
					throw error;
				});
			}
		});
	};
};

export const fetchAgent = (id) => {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			if (api.agentsUrl) {
				const apiUrl = api.agentsUrl + `?id=${id}&user=${userEmail}`;

				return fetch(apiUrl, {
					method: "GET",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				})
				.then((response) => (response.json()))
				.then((agentData) => {
					dispatch({ type: FETCH_AGENT_SUCCESS, payload: agentData[0] });
				})
				.catch((error) => {
					console.error("Fetch Agent Error", error);
					dispatch({ type: FETCH_AGENT_FAILURE, error });
					throw error;
				});
			}
		});
	};
};

export const deleteAgent = (id) => {
	return (dispatch, getState) => {
		const { api, userEmail } = getState().login;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			if (api.agentsUrl) {
				const apiUrl = api.agentsUrl + `?id=${id}&user=${userEmail}`;

				return fetch(apiUrl, {
					method: "DELETE",
					mode: "cors",
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				})
				.then((response) => response.json())
				.catch((error) => {
					console.error("Delete Agent Error", error);
					throw error;
				});
			}
		});
	};
};

export const updateAgent = (agent) => {
	return (dispatch, getState) => {
		const { api, userData, userEmail } = getState().login;
		const userPool = userData && userData.pool && userData.pool.userPoolId;

		// Get / Refresh tokens	and send request	
		return checkRefreshToken().then(({accessToken, idToken}) => {
			if (api.agentsUrl) {
				const apiUrl = api.agentsUrl + `?id=${agent.id}&user=${userEmail}`;

				return fetch(apiUrl, {
					method: "POST",
					mode: "cors",
					body: JSON.stringify(agent),
					headers: {
						"Content-Type": "application/json",
						Authorization: idToken,
					},
				})
				.then((response) => response.json())
				.catch((error) => {
					console.error("Update Agent Error", error);
					throw error;
				});
			}
		});
	};
};



// Biographical Agent - Relation/Edge Data
let agentEntityRelationDataAbortController;
const abortAgentEntityRelationDataFetch = () => {
	if (agentEntityRelationDataAbortController) {
		agentEntityRelationDataAbortController.abort();
	}
};

const doFetchAgentEntityRelationData = (parameters) => {
	const { dispatch, getState, edge } = parameters;
	const { aiOnly } = getState().commonUI;
	const { entityRelationDataFetchCount } = getState().agents.agentData.bio;
	const { api, userEmail, userData } = getState().login;
	const userPool = userData && userData.pool && userData.pool.userPoolId;

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { entityRelationDataLoading } = getState().agents.agentData.bio;
		if (entityRelationDataLoading) {
			abortAgentEntityRelationDataFetch();
		}
		agentEntityRelationDataAbortController = new AbortController();
		return fetch(
			`${api.singleArticle}?id=${edge.id}&index=${edge.index}&ai=${aiOnly}&getDoc=unsafe&email=${userEmail}&project=${api.project}`,
			{
				method: "GET",
				signal: agentEntityRelationDataAbortController.signal,
				mode: "cors",
				headers: {
					"Content-Type": "application/json",
					Authorization: idToken,
				},
			}
		)
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				const transformedEdge = edgeTransformer(json);
				dispatch({ type: AGENT_RECEIVE_ENTITY_RELATION_DATA, data: transformedEdge });
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (entityRelationDataFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: AGENT_RECEIVE_ENTITY_RELATION_DATA_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${entityRelationDataFetchCount + 1}...`);
					dispatch({ type: AGENT_RECEIVE_ENTITY_RELATION_DATA_RETRY });
					doFetchAgentEntityRelationData(parameters);
				}
			});
	});
};

export const fetchAgentEntityRelationData = (edge) => {
	return (dispatch, getState) => {
		dispatch({ type: AGENT_FETCH_ENTITY_RELATION_DATA, edge });
		doFetchAgentEntityRelationData({ dispatch, getState, edge });
	};
};

// Biographical Agent - Affiliations Graph Data
let agentEntityGraphAbortController;
const abortAgentEntityGraphFetch = () => {
	if (agentEntityGraphAbortController) {
		agentEntityGraphAbortController.abort();
	}
};

const doFetchAgentEntityGraph = (parameters) => {
	const { dispatch, getState, entityId, agentId, depth } = parameters;
	const { graphDataFetchCount } = getState().agents.agentData.bio;
	const { api, userData, userName } = getState().login;
	const userPool = userData && userData.pool && userData.pool.userPoolId;

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { graphDataLoading } = getState().agents.agentData.bio;
		if (graphDataLoading) {
			abortAgentEntityGraphFetch();
		}
		agentEntityGraphAbortController = new AbortController();
		return fetch(`${api.entityGraph}`, {
			method: "POST",
			signal: agentEntityGraphAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				project: api.key,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
				id: entityId,
				agent_id: agentId,
				dataset: DATASET_ID_ENTITIES,
				recursionLimit: depth,
				edgeLimit: 9999,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				const { edgeMap, nodeMap, graphData } = graphTransformer(json, entityId);
				dispatch({ type: AGENT_RECEIVE_GRAPH_DATA, data: graphData, edgeMap, nodeMap });
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (graphDataFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: AGENT_RECEIVE_GRAPH_DATA_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${graphDataFetchCount + 1}...`);
					dispatch({ type: AGENT_RECEIVE_GRAPH_DATA_RETRY });
					doFetchAgentEntityGraph(parameters);
				}
			});
	});
};

export const fetchAgentEntityGraph = (entityId, agentId, depth) => {
	return (dispatch, getState) => {
		dispatch({ type: AGENT_FETCH_GRAPH_DATA });
		doFetchAgentEntityGraph({ dispatch, getState, entityId, agentId, depth: depth || 3 });
	};
};

// Entity View - Expand Affiliations Graph Data
let agentExpandEntityGraphAbortController;
const abortAgentExpandEntityGraphFetch = () => {
	if (agentExpandEntityGraphAbortController) {
		agentExpandEntityGraphAbortController.abort();
	}
};

const doExpandAgentEntityGraph = (parameters) => {
	const { dispatch, getState, entity, depth, nodeCoords } = parameters;
	const { graphExpandFetchCount, graphEdgeMap, graphNodeMap, graphData } = getState().agents.agentData.bio;
	const { api, userData, userName } = getState().login;
	const userPool = userData && userData.pool && userData.pool.userPoolId;

	// Get / Refresh tokens	and send request	
	return checkRefreshToken().then(({accessToken, idToken}) => {
		const { graphExpanding } = getState().agents.agentData.bio;
		if (graphExpanding) {
			abortAgentExpandEntityGraphFetch();
		}
		agentExpandEntityGraphAbortController = new AbortController();
		return fetch(`${api.entityGraph}`, {
			method: "POST",
			signal: agentExpandEntityGraphAbortController.signal,
			mode: "cors",
			body: JSON.stringify({
				project: api.key,
				userName,
				userPool,
				user: `${userName}_${userPool}`,
				id: entity.id,
				dataset: DATASET_ID_ENTITIES,
				recursionLimit: depth,
				edgeLimit: 9999,
			}),
			headers: {
				"Content-Type": "application/json",
				Authorization: idToken,
			},
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error(SERVER_ERROR);
				}
				return response.json();
			})
			.then((json) => {
				const res = graphExtendTransformer(graphData, graphEdgeMap, graphNodeMap, json, nodeCoords);
				dispatch({
					type: AGENT_RECEIVE_EXPAND_GRAPH_DATA,
					data: res.graphData,
					edgeMap: res.edgeMap,
					nodeMap: res.nodeMap,
					isChanged: res.hasChanges,
					numNodesAdded: res.numNodesAdded,
					numEdgesAdded: res.numEdgesAdded,
				});
			})
			.catch((error) => {
				if (error.name === "AbortError") {
					// No action needed
				} else if (graphExpandFetchCount >= FETCH_RETRY_MAX) {
					console.error(error);
					dispatch({ type: AGENT_RECEIVE_EXPAND_GRAPH_DATA_ERROR });
				} else {
					console.warn(`${error} - Retry attempt ${graphExpandFetchCount + 1}...`);
					dispatch({ type: AGENT_RECEIVE_EXPAND_GRAPH_DATA_RETRY });
					doExpandAgentEntityGraph(parameters);
				}
			});
	});
};

export const expandAgentEntityGraph = (entity, depth, nodeCoords) => {
	return (dispatch, getState) => {
		const { graphExpandDepth } = getState().agents.agentData.bio;
		dispatch({ type: AGENT_FETCH_EXPAND_GRAPH_DATA });
		doExpandAgentEntityGraph({
			dispatch,
			getState,
			entity,
			depth: depth || graphExpandDepth,
			nodeCoords,
		});
	};
};

export async function openEntitySourcesFile(url) {
	const {accessToken, idToken} = await checkRefreshToken(); 
	const requestOptions = {
		method  : 'GET',
		headers: {
			Authorization: idToken,
		},
	};
	const res = await fetch(url, requestOptions);
	const uint8arr = new Uint8Array(await new Response(res.body).arrayBuffer());
	const link = document.createElement('a');
	const blob = new Blob([uint8arr], { type: 'application/pdf' });
	link.href = window.URL.createObjectURL(blob);
	link.setAttribute("target", "_blank");
	link.setAttribute("rel", "noreferrer noopener");
	document.body.appendChild(link);
	link.click();
	link.remove();
}